/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-array-constructor */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-self-assign */
/* eslint-disable no-var */
import { AuthService } from "./../../../common/services/auth.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { IMember } from "app/shared/Domains/member";
import { IMemberContact } from "app/shared/Domains/memberContact";
import { IAddress } from "app/shared/Domains/address";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";
import { HttpClient } from "@angular/common/http";
import { Configuration } from "config/config";
import { IMemberFeeDetails } from "app/shared/Domains/feeDetail";
import { ICompany } from "app/shared/Domains/company";
import { ISettings } from "app/shared/Domains/settings";
import { IMemberEmergencyContact } from "app/shared/Domains/memberEmergencyContact";
import { WebcamImage, WebcamInitError, WebcamUtil } from "ngx-webcam";
import { Customerstrainer } from "app/shared/Domains/Customerstrainer";
import { IMemberFreezeDetail } from "app/shared/Domains/memberFreezeDetail";
import { DatePipe } from "@angular/common";
import { IUser } from "app/shared/Domains/IUser";
import { IRole } from "app/shared/Domains/role";
import { MemberService } from "common/services/member.service";
import { IPackageBuider } from "app/shared/Domains/packageBuilder";
import globalVariable from "../../../globalVariable/globalVariable.json";
import { IEmailFields } from "app/shared/Domains/emailFields";
import { NgxSpinnerService } from "ngx-spinner";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { DataService } from "app/shared/data.service";
import { IBranch } from "app/shared/Domains/branch";
import { AppUtils } from 'common/services/app.util';
import moment from "moment";
import { Observable } from "rxjs";
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IService } from "app/services/models/service";
import { ISubscription } from "app/services/models/subscription";
import { IFeeDetailPrint } from "app/shared/Domains/feeDetailPrint";
import { SingleReceiptPrintComponent } from "app/shared/receipt/single-receipt-print/single-receipt-print.component";
import { SingleReceiptEmailComponent } from "app/shared/receipt/single-receipt-email/single-receipt-email.component";
import { ISubscriptionFee } from "app/services/models/subscriptionFee";
@Component({
    selector: "app-add-members",
    templateUrl: "./add-members.component.html",
    host: { "(window:keyup)": "hotkeysMemberDetails($event)" },
    styleUrls: ["./add-members.component.css"],
})
export class AddMembersComponent implements OnInit {
    public Editor = ClassicEditor;
    @ViewChild(SingleReceiptPrintComponent) singleReceiptPrintComponent: SingleReceiptPrintComponent;
    @ViewChild(SingleReceiptEmailComponent) singleReceiptEmailComponent: SingleReceiptEmailComponent;
    servicesPackageName:string = "";
    trainerPackageId: string;
    passwordType1: string = "password";
    passwordType2: string = "password";
    passwordType3: string = "password";
    addProfileImage: any;
    nPassword: string = "";
    cPassword: string = "";
    member: IMember;
    paymentMode: any;
    errorExempleNumber: any;
    company: ICompany;
    branch: IBranch;
    mode: string;
    branchName: string;
    subscription: any;
    options: any[];
    statusOptions: any[];
    trainerOptions: any[];
    loading: boolean;
    Trainers: any[];
    fund: IMemberFeeDetails;
    subscriptionFeeSinglePrint: IFeeDetailPrint;
    fundInvoice: IMemberFeeDetails;
    fundCollectiveInvoice: IMemberFeeDetails[] = [];
    memberID: any;
    feeDetailsSource: any;
    printAllFeeTotal: any = {};
    uploadProfile: any;
    uploadProfilePath: any;
    dialogVisibility: boolean;
    feeTotal: number;
    feeTotalTax: number;
    remainingBalance: any;
    selectedOption: any;
    date: any;
    dialogVisible: boolean;
    seletedStatus: any;
    public webcamImage: WebcamImage = null;
    months: any[];
    years: any[];
    array: any[];
    freezeMemberDetails: any[];
    difference: number;
    feegreater: Boolean;
    feealreadypaid: Boolean;
    trainerNotSelected = false;
    memeberSetting: boolean = true;
    sessionCountChanged: boolean = false;
    role: IRole;
    user: IUser;
    packageName: any;
    packageNameUpdate: any;
    oldPassword: any;
    newPassword: any = '';
    index: any = '';
    confirmPass: any;
    newConfirmPassword: any;
    packages: IPackageBuider[] = [];
    packagesDropDown: any[] = [];
    isShowAddProfileImage: boolean;
    showEmailReceiptConfirmationBox: boolean = false;
    showEmailSingleReceiptConfirmationBox: boolean = false;
    showCommentBox: boolean = false;
    htmlToPdf: any;
    showActiceFreezeBox: boolean = false;
    isFeeRecord: boolean = false;
    email: IEmailFields;
    isGymShareMoreThanTrainerFee: boolean = false;
    isEmailExist: boolean = false;
    isEmailLoader: boolean = false;
    timer: any;
    isDisableOnTypeEmail: boolean;
    dbEmailIfCustomerHAve: any;
    currentUser = '';
    companySessionStorage = '';
    branchSessionStorage = '';
    oldMemberImage: any;
    numOfMonths: number;
    previousDueDate: Date;
    firstInvoice: string;
    memberTrainer: any;
    openFeeDialog: any;
    imgPreview: boolean = false;
    imgPreviewImg: any;
    allowDialog: boolean;
    isDialogVisible: boolean;
    isFeeMessageVisible: boolean = true;
    currentUserData: any;
    packageToShowName: any;
    updateMemberSettingFlag: boolean = false;
    showCommentDialog: boolean = false;
    dialogDescription: any = '';
    registrationPaid = false;
    monthlyPaid = false;
    trainerPaid = false;
    discountAmount: number = 0;
    feeTotalDiscount: number;
    packageFee: any;
    packageRegistrationFee: any;
    showMonthlyFeeError: boolean = false;
    showRegistrationFeeError: boolean = false;
    showTrainerFeeError: boolean = false;
    numberOfMembers: any;
    confirmationBoxMessage: any;
    paymentOptions: any;
    allPaymentOptions: any;
    sessionCount: any;
    selectedFile: File;
    selectedFileName: string;
    modifiedFileName: string;
    trainerSessions: any;
    activityLogsResult: any[] = [];
    from: any;
    to: any;
    welcomeMsg:boolean;
    taxType :string;
    taxRate: number;
    feeInvoiceDialog: boolean = false;
    feeInvoiceDialogCheck: boolean = false;
    canAddSubscription: boolean = true;
    subscriptionTabActive: boolean = false;
    addSubscriptionPopupVisible: boolean = false;
    countries: any[];
    selectedSubscription: any;
    selectedTrainerInSubscriptionDb: any;
    selectedTrainerFee: any;
    subscriptionFee: number;
    subscriptionDiscount: number;
    subscriptionTax: number;
    SubscriptionPopupLoading: boolean = true;
    allSubscriptions: any[];
    selectedTrainerInSubscription: SelectItem;
    trainersInSubscription: SelectItem[];
    services: IService[];
    subscribedServices: IService[];
    serviceInDetailView: IService[];
    serviceSubscriptions: ISubscription[];
    subscriptions: ISubscription[];
    allSubscriptionsFee:ISubscriptionFee[];
    subFee:any;
    subscriptionDetail: any;
    activeSubscriptionSessionsList = [];
    selectedServiceForSubscription: IService;
    hideTaxInfo: boolean=false;
    sessionsStartDate: Date;
    subscriptionsDetailView: boolean = false;
    isActiveSubscriptionAvailable: boolean = false;
    whatsAppCommunityLink: any;
    isPackageUpdated: boolean = false;
    whatsAppCommunityLinkMessage: string;
    description: any;
    serviceType: string;
    invoiceData: any;
    customerPackageId = '';
    formattedNumber: string = '';
    isPackageDialogVisible: boolean = false;
    selectedPackageId: string | undefined;
    customerFees: any;
    dateOfBirthError: boolean = false;
    selectedIdentityType: string = 'CNIC';
    errorMessage: string = '';
    showBodySpecPopup = false;
    getBodySpecs :[] = [];
    selectedBodySpec: any = null
    addVitalsDialog: boolean = false;
    updateBodySpecDialogVisible = false;
    bodySpec = {
        totalBodyWater: 0,
        protein: 0,
        mineral: 0,
        bodyFatMass: 0,
        weight: 0,
        sMM: 0,
        bMI: 0,
        pBF: 0,
        waistHipRatio: 0,
        visceralFatLevel: 0,
        height: 0,
        _id: 0,
    };
    constructor(
        private LanguageService: LanguageService,
        private memberService: MemberService,
        private route: ActivatedRoute,
        private router: Router,
        private loader: NgxSpinnerService,
        private confirmationService: ConfirmationService,
        private datePipe: DatePipe,
        private _http: HttpClient,
        public config: Configuration,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager,
        private dataService: DataService
    ) {
        route.params.subscribe((params) => {
            if (this.memberID === undefined) {
                this.memberID = params["id"];
                if (params["openFeeDialog"])
                    this.openFeeDialog = params["openFeeDialog"]
            } else if (this.memberID !== params["id"]) {
                this.memberID = params["id"];
                this.getCustomerByID();
                this.getCustomerFees();
            }
            if (params && params.defaulter == "true"
                || params && params.fee == "true") {
                this.index = 1;
                this.getCustomerFees();
            } else {
                this.index = 0;
            }
        });
    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("AddMembersComponent", label);
      }
    ngOnInit() {
        this.discountAmount = 0;
        this.subscriptionFeeSinglePrint = new IFeeDetailPrint();
        this.subscriptionFeeSinglePrint.invoice = "";
        this.subscriptionFeeSinglePrint.createdDate = new Date();
        this.subscriptionFeeSinglePrint.startDate = new Date();
        this.subscriptionFeeSinglePrint.endDate = new Date();
        this.subscriptionFeeSinglePrint.membershipNumber = "";
        this.subscriptionFeeSinglePrint.memberName = "";
        this.subscriptionFeeSinglePrint.feeType = "";
        this.subscriptionFeeSinglePrint.fee = "";
        this.subscriptionFeeSinglePrint.tax = "";
        this.subscriptionFeeSinglePrint.discount = "";
        this.subscriptionFeeSinglePrint.taxRate = 0;
        this.subscriptionFeeSinglePrint.taxCalculationType = "";
        this.subscribedServices = [];
        this.subscriptionDiscount = 0;
        this.sessionsStartDate = new Date();
        this.subscriptionTax = 0;
        this.paymentOptions = [
            { label: 'Cash - Reception', value: 'Cash-Reception' },
        ];
        this.isDialogVisible = true;
        this.currentUser = localStorage.getItem('currentUser');
        const currentUseroBJ = JSON.parse(this.currentUser);
        this.currentUserData = currentUseroBJ;
        this.companySessionStorage = currentUseroBJ.company;
        this.branchSessionStorage = currentUseroBJ.branch;
        this.paymentMode = "Cash-Reception";
        console.log("this.companySessionStorage", this.companySessionStorage)
        this.getBranchById();
        this.addProfileImage = "Cam"; // Upload | Cam
        this.errorExempleNumber = globalVariable.exampledata.pakNumber;
        this.user = AuthService.getLoggedInUser();
        this.role = AuthService.getLoggedInRole();
        if (this.role.name === "Admin" || this.role.name === "Super Admin") {
            this.memeberSetting = false;
        } else {
            this.memeberSetting = true;
        }
        this.initObjects();
        this.loading = false;
        this.dialogVisibility = false;
        this.dialogVisible = false;
        this.member.contactDetail.address.country = "Pakistan";
        // this.member.contactDetail.address.city = "Islamabad";
        var date = new Date();
        this.from = new Date(date.getFullYear(), date.getMonth(), 1);
        this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.from.setHours(0, 0, 0, 0);
        this.to.setHours(23, 59, 59, 999);
        this.getCompany();
        this.getBranch();
        this.getTrainers();
        this.getPackages();
        this.getBodySpecification();
        this.date = new Date();
        this.email = new IEmailFields();
        if (this.memberID !== null && this.memberID !== undefined) {
            this.mode = "edit";
            this.getCustomerByID();
            this.getCustomerFees();
        } else {
            this.mode = "add";
            this.breadcrumbService.setItems([
                { label: "Member Management" },
                { label: "All Members", routerLink: "/members" },
                { label: "Add New member" },
            ]);
        }

    }


    ptOpenWhatsApp(member, subscribedService) {
        console.log('Send PT Fee Reminder for:', subscribedService);
        // Get member's WhatsApp number
        const receiver = member.contactDetail?.contact || member.contact;
        if (!receiver) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: 'This user does not have a phone number',
            });
            return '';
        }

        // Gather PT services/subscriptions (customize as per your data structure)
        const ptServices = (this.subscriptions || []).filter(s => s.type === 'trainingService' && s.serviceId !== 'Expired');
        if (!ptServices.length) {
            this.messageService.clear();
            this.messageService.add({
                severity: "info",
                summary: "Info Message",
                detail: 'No active PT services found for this member.',
            });
            return '';
        }

        // Build the message
        let msg = `*Personal Training Service Renewal Reminder*\n\nDear ${member.name},\n\nHere are your Expired PT services:\n`;
        const today = new Date();
        const expiredServices = ptServices.filter(service => {
            if (!service.dueDate) return false;
            const due = new Date(service.dueDate);
            due.setHours(0, 0, 0, 0);
            return due < today;
        });
        expiredServices.forEach((service, idx) => {
            const trainerName = this.getSubscriptionTrainer(service.trainerId) || 'N/A';
            const expiry = service.dueDate ? new Date(service.dueDate).toLocaleDateString() : 'N/A';
            msg += `\n${idx + 1}. *${service.name || 'Service'}*`;
            msg += `\n   Trainer: ${trainerName}`;
            msg += `\n   Sessions: ${service.numberOfSessions || 'N/A'}`;
            msg += `\n   Expiry: ${expiry}\n`;
        });

        msg += `\nPlease renew your PT services to continue enjoying uninterrupted training sessions. If you have any questions, feel free to contact us.\n\nThank you!\n${this.branchName || ''}`;

        // Add WhatsApp community link if available
        if (this.whatsAppCommunityLink) {
            msg += `\n\nJoin our WhatsApp community: ${this.whatsAppCommunityLink}`;
        }

        const message = encodeURIComponent(msg);

        // Open WhatsApp
        const link = document.createElement('a');
        link.href = `https://wa.me/${receiver}?text=${message}`;
        link.target = '_blank';
        link.click();

        return '';
    }
    getBranch() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            let length;
            this.invoiceData = this.branch.invoiceData;
            if (Array.isArray(this.branch.payments)) {
                length = this.branch.payments.length;
                this.taxType = this.branch.payments[length-1].taxSettings.taxCalculationType;
                this.taxRate = this.branch.payments[length-1].taxSettings.taxRate;
                const paymentModes = this.branch.payments.filter(x => x.taxSettings.taxCalculationType == "NO_TAX");
                if(paymentModes.length == this.branch.payments.length) {
                    this.hideTaxInfo = true;
                }
            }
        }
        if(!this.branch){
            this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
                if (res) {
                    this.branch = res;
                    this.invoiceData = res.invoiceData;
                    let length;
                    if (Array.isArray(this.branch.payments)) {
                        length = this.branch.payments.length;
                    }
                    this.taxType = this.branch.payments[length-1].taxSettings.taxCalculationType;
                    this.taxRate = this.branch.payments[length-1].taxSettings.taxRate;
                    const paymentModes = res.payments.filter(x => x.taxSettings.taxCalculationType == "NO_TAX");
                    if(paymentModes.length == res.payments.length) {
                      this.hideTaxInfo = true;
                    }

                } else {
                    this.branch = new IBranch();
                    this.messageService.clear();
                    this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
                }
            },
                (error) => {
                    this.branch = new IBranch();
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                });
        }
    }

    getActivityLogs() {
        this.loading = true;
        const formatDate = (date: Date) => {
            return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
          };
          const formattedFrom = formatDate(new Date(this.from));
          const formattedTo = formatDate(new Date(this.to));
        if (this.from <= this.to) {
          const apiUrl = `activityLogs/company/${AuthService.getLoggedInCompany()}/branch/${AuthService.getLoggedInBranch()}/member/${this.member._id}?dateFrom=${formattedFrom}&dateTo=${formattedTo}`;

          this.appServiceManager.get(apiUrl).subscribe(
            (requests) => {
              if (requests.length === 0) {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
              }
              this.activityLogsResult = requests.response;
              this.loading = false;
            },
            (error) => {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
          );
        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'From Date is greater than To Date' });
        }
      }


    showPackageDialog(){
        this.isPackageDialogVisible = true;
        this.selectedPackageId = undefined;
    }

    subscribeService() {
        console.log(0);
        if (this.selectedServiceForSubscription === null || this.selectedServiceForSubscription === undefined) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select a valid subscription.",
            });
        }
        if (this.selectedTrainerInSubscriptionDb === null || this.selectedTrainerInSubscriptionDb === undefined) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select a valid subscription.",
            });
        }
        if (this.selectedTrainerFee === null || this.selectedTrainerFee === undefined) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please select a valid subscription.",
            });
        }

        const feeObj = {
            paymentMode: this.paymentMode,
            taxType: this.taxType,
            taxRate: this.taxRate,
            tax: this.subscriptionTax,
            fee: this.subscriptionFee,
            discount: this.subscriptionDiscount,
            description : this.description,
        };

        const subscriptionObj = {
            service: this.selectedServiceForSubscription,
            trainer: this.selectedTrainerInSubscriptionDb,
            trainerPackage: this.selectedTrainerFee,
            fee: feeObj,
            currentUserData: this.currentUserData,
            subscriberType: "Member",
            initiatedFrom: "Member",
            type: "Subscription",
            subscriberId: this.memberID,
            startDate: this.sessionsStartDate,
            sessionsFrequency: 0,
            subscriberName: this.member.name,
            subscriberMembership: this.member.tagNumber,
            subscriptionStartDate: this.sessionsStartDate,
            createdBy: this.currentUserData.name,
            company:this.user.company,
            branch:this.user.branch,
            description:this.description,

        };


        this.appServiceManager.post("subscriptions/", subscriptionObj)
            .subscribe(
                (res) => {
                    this.getAllSubscriptions();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Subscription added successfully.",
                    });
                    console.log("getSingleSubscriptionFeePrint",res);
                    this.subscriptionFeePrint(res.response.subscriptionFee);
                    this.addSubscriptionPopupVisible = false;
                },
                (error) => {
                    console.log(error);
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: "Add Subscription failed.",
                    });
                });
    }

    subscriptionFeePrint(subscriptionFee){
        const fee = subscriptionFee;
                    this.subscriptionFeeSinglePrint.invoice = fee.invoice;
                    this.subscriptionFeeSinglePrint.createdDate = new Date(fee.date);
                    this.subscriptionFeeSinglePrint.startDate = new Date(fee.start);
                    this.subscriptionFeeSinglePrint.endDate = new Date(fee.end);
                    this.subscriptionFeeSinglePrint.membershipNumber = fee.subscriberMembership;
                    this.subscriptionFeeSinglePrint.memberName = fee.subscriberName;
                    this.subscriptionFeeSinglePrint.feeType = fee.status;
                    this.subscriptionFeeSinglePrint.fee = fee.pay;
                    this.subscriptionFeeSinglePrint.tax = fee.tax;
                    this.subscriptionFeeSinglePrint.discount = fee.discount;
                    this.subscriptionFeeSinglePrint.taxRate = fee.taxRate;
                    this.subscriptionFeeSinglePrint.taxCalculationType = fee.taxType;
                    setTimeout(() => {
                        this.singleReceiptPrintComponent.initiatePrintInvoice(this.subscriptionFeeSinglePrint);
                    }, 300);
    }

    getNthTypeDay(d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
        }
    }

    handleChange(e) {
        if (e.index === 1) {
            if (this.member.settings.dueDate) {
                if (
                    this.member.isDelete == false &&
                    this.member.freezeDetail.isFreeze == false
                ) {
                    let dueDate = new Date(this.member.settings.dueDate).getDate();
                    if (dueDate >= 20 && dueDate <= 31) {
                        this.appServiceManager
                            .get("customers/feeCheckMonth/" + this.member._id)
                            .subscribe(
                                (res: Date) => {
                                    this.fund.month =
                                        new Date(res).getMonth() + 1;
                                },
                                (error: any) => {
                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "error",
                                        summary: "Error Message",
                                        detail: error,
                                    });
                                }
                            );
                    } else {
                        var date = new Date();
                        this.fund.month = date.getMonth() + 1;
                    }
                }
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Due Date is not Selected!",
                });
            }
        }
        if (e.index === 2) {
            this.subscriptionTabActive = true;
        }
        else {
            this.subscriptionTabActive = false;
        }
    }

    subscriptionSelectionChanged() {
        console.log(this.selectedSubscription);
        this.selectedServiceForSubscription = this.services.filter(t => t._id === this.selectedSubscription.serviceId)[0];
        this.serviceType = this.selectedServiceForSubscription.type;
        if(this.selectedServiceForSubscription.type === 'selfService'){
            this.selectedTrainerInSubscriptionDb = this.selectedServiceForSubscription.packages.filter(t => t._id === this.selectedSubscription.feeId);
            this.selectedTrainerFee = this.selectedTrainerInSubscriptionDb[0];
            this.subscriptionFee   = parseInt(this.selectedTrainerFee.packageFee);
        }else{
        this.selectedTrainerInSubscriptionDb = this.Trainers.filter(t => t._id === this.selectedSubscription.trainerId)[0];
        this.selectedTrainerFee = this.selectedTrainerInSubscriptionDb.fees.filter(t => t._id === this.selectedSubscription.feeId)[0];
        this.subscriptionFee = this.selectedTrainerFee.totalFee;
        }
        this.onPaymentModeChange(this.paymentMode);
    }

    openAddSubscriptionDialog() {
        this.addSubscriptionPopupVisible = true;
        this.getAllServices();
    }

    getAllSubscriptions() {
        this.appServiceManager.get("subscriptions/" + this.memberID + "/all").subscribe(
            (res) => {
                if (res) {
                    this.subscriptions = res.response;
                    this.getAllServices();
                    this.getAllSubscriptionFee();
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }
    getAllSubscriptionFee() {
        this.appServiceManager.get("subscriptionFee/" + this.memberID + "/all").subscribe(
            (res) => {
                if (res) {
                    this.allSubscriptionsFee = res.response;
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    getServiceStatus(serviceId){
        let servicesSubscriptions = this.subscriptions.filter(ss => ss.serviceId == serviceId);
        let check = false;
        servicesSubscriptions.forEach(s => {
            let status = this.getSubscriptionStatus(s.dueDate);
            if(status == "Active") {
                check = true;
            }
        });
        if(check) {
            return "Active";
        }
        return "Expired";
    }

    getSubscriptionType(type) {
        if(type === "trainingService") {
            return "Training Service";
        }else if(type === "selfService"){
            return "Self Service"
        }
    }

    getSubscriptionTrainer(trainerId) {
        return this.Trainers.filter(t => t._id === trainerId)[0].name;
    }

    showSubscriptionDetails(services) {
        if(services.type === 'selfService'){
        this.prepareSelfServiceDetailData(services);
    }else{
        this.prepareServiceDetailData(services);
    }
        this.subscriptionsDetailView = true;
    }

    prepareServiceDetailData(services) {
        this.serviceSubscriptions = [];
        this.activeSubscriptionSessionsList = [];
        this.serviceSubscriptions = this.subscriptions.filter(s => s.serviceId == services._id);
        this.serviceInDetailView = services;
        let activeTrainers = "";
        let activeTrainersList = [];
        let totalActiveSessions = 0;
        let totalActiveConductedSessions = 0;
        let activeSessionsStartDate = new Date();
        activeSessionsStartDate.setDate(activeSessionsStartDate.getDate() + 5)
        let activeSessionsDueDate = new Date();
        this.serviceSubscriptions.forEach(ss => {
            let check = this.getSubscriptionStatus(ss.dueDate);
            if(check == "Active") {
                this.isActiveSubscriptionAvailable = true;
                this.getTotalConductedSessions(ss._id);
                let trainerCheck = activeTrainersList.filter(x => x == ss.trainerId);
                if(trainerCheck.length == 0) {
                    let trainerName = this.getSubscriptionTrainer(ss.trainerId);
                    if(activeTrainers.length != 0) {
                        trainerName = ", "+ trainerName;
                    }
                    activeTrainers += trainerName;
                    activeTrainersList.push(ss.trainerId);
                }
                totalActiveSessions += ss.numberOfSessions;
                totalActiveConductedSessions += 0;
                if(this.getOlderDateInLoopOfSubscriptions(activeSessionsStartDate, ss.startDate)) {
                    activeSessionsStartDate = new Date(ss.startDate);
                }
                else {
                    activeSessionsStartDate = new Date(ss.startDate);
                }
                if(this.getDueDateInLoopOfSubscriptions(activeSessionsDueDate, ss.dueDate)) {
                    activeSessionsDueDate = new Date(ss.dueDate);
                }
            }
            this.subFee = this.allSubscriptionsFee.filter(x=>x.subscriptionId == ss._id);
            ss.pay=this.subFee[0].pay;
            ss.tax=this.subFee[0].tax;
            ss.paymentMode=this.subFee[0].paymentMode;
            ss.discount=this.subFee[0].discount;
            ss.description=this.subFee[0].description;
        });
        this.subscriptionDetail = {};
        this.subscriptionDetail.trainers = activeTrainers;
        this.subscriptionDetail.totalSessions = totalActiveSessions;
        this.subscriptionDetail.totalConductedSessions = totalActiveConductedSessions;
        this.subscriptionDetail.startDate = activeSessionsStartDate;
        this.subscriptionDetail.dueDate = activeSessionsDueDate;
        this.subscriptionDetail.totalNoShowSessions = 0;
        this.subscriptionDetail.remainingSessions = totalActiveSessions - totalActiveConductedSessions;

        this.serviceSubscriptions = this.serviceSubscriptions.sort((a:any, b:any) => Date.parse(b.dueDate) - Date.parse(a.dueDate));
    }

    prepareSelfServiceDetailData(services) {
        this.serviceSubscriptions = [];
        this.activeSubscriptionSessionsList = [];
        this.serviceSubscriptions = this.subscriptions.filter(s => s.serviceId == services._id);
        this.serviceInDetailView = services;
        let activeTrainers = "";
        let activeTrainersList = [];
        let totalActiveSessions = 0;
        let totalActiveConductedSessions = 0;
        let activeSessionsStartDate = new Date();
        activeSessionsStartDate.setDate(activeSessionsStartDate.getDate() + 5)
        let activeSessionsDueDate = new Date();
        this.serviceSubscriptions.forEach(subscription => {
            subscription.servicePackageNames = []; // Initialize as an empty array

            services?.packages.forEach(pkg => {
                if (subscription.trainerPackageId === pkg._id) {
                    subscription.servicePackageNames.push(pkg.name); // Store all matching package names
                }
            });
        });

        this.serviceSubscriptions.forEach(ss => {
            let check = this.getSubscriptionStatus(ss.dueDate);
            if(check == "Active") {
                this.isActiveSubscriptionAvailable = true;
                this.getTotalConductedSessions(ss._id);
                totalActiveSessions += ss.numberOfSessions;
                totalActiveConductedSessions += 0;
                if(this.getOlderDateInLoopOfSubscriptions(activeSessionsStartDate, ss.startDate)) {
                    activeSessionsStartDate = new Date(ss.startDate);
                }
                else {
                    activeSessionsStartDate = new Date(ss.startDate);
                }
                if(this.getDueDateInLoopOfSubscriptions(activeSessionsDueDate, ss.dueDate)) {
                    activeSessionsDueDate = new Date(ss.dueDate);
                }
            }
            this.subFee = this.allSubscriptionsFee.filter(x=>x.subscriptionId == ss._id);
            ss.pay=this.subFee[0].pay;
            ss.tax=this.subFee[0].tax;
            ss.paymentMode=this.subFee[0].paymentMode;
            ss.discount=this.subFee[0].discount;
            ss.description=this.subFee[0].description;
        });
        this.subscriptionDetail = {};
        this.subscriptionDetail.trainers = activeTrainers;
        this.subscriptionDetail.totalSessions = totalActiveSessions;
        this.subscriptionDetail.totalConductedSessions = totalActiveConductedSessions;
        this.subscriptionDetail.startDate = activeSessionsStartDate;
        this.subscriptionDetail.dueDate = activeSessionsDueDate;
        this.subscriptionDetail.totalNoShowSessions = 0;
        this.subscriptionDetail.remainingSessions = totalActiveSessions - totalActiveConductedSessions;

        this.serviceSubscriptions = this.serviceSubscriptions.sort((a:any, b:any) => Date.parse(b.dueDate) - Date.parse(a.dueDate));
    }

    getTotalConductedSessions(id) {
        this.appServiceManager.get("subscriptions/" + id + "/allSessions").subscribe(
            (res) => {
                if (res) {
                    console.log(res);
                    this.activeSubscriptionSessionsList.concat(res.response);
                    const conductedSessions = res.response.filter(d => d.status === "ATTENDED").length;
                    const noShowSessions = res.response.filter(d => d.status === "NO–SHOW").length;
                    this.subscriptionDetail.totalConductedSessions += conductedSessions;
                    this.subscriptionDetail.totalNoShowSessions += noShowSessions;
                    this.subscriptionDetail.remainingSessions -= (conductedSessions + noShowSessions);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    getSingleSubscriptionFeeWhatsapp(id, due) {
        this.appServiceManager.get("subscriptionFee/" + id + "/feeBySubscriptionId").subscribe(
            (res) => {
                if (res) {
                    console.log(res);
                    const fee = res.response[0];
                    setTimeout(() => {
                        this.openWhatsAppForSubscriptionFee(fee, due);
                    }, 300);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    getSingleSubscriptionFeePrint(id, start, end) {
        this.appServiceManager.get("subscriptionFee/" + id + "/feeBySubscriptionId").subscribe(
            (res) => {
                if (res) {
                    console.log(res);
                    const fee = res.response[0];
                    this.subscriptionFeeSinglePrint.invoice = fee.invoice;
                    this.subscriptionFeeSinglePrint.createdDate = new Date(fee.date);
                    this.subscriptionFeeSinglePrint.startDate = new Date(start);
                    this.subscriptionFeeSinglePrint.endDate = new Date(end);
                    this.subscriptionFeeSinglePrint.membershipNumber = fee.subscriberMembership;
                    this.subscriptionFeeSinglePrint.memberName = fee.subscriberName;
                    this.subscriptionFeeSinglePrint.feeType = fee.status;
                    this.subscriptionFeeSinglePrint.fee = fee.pay;
                    this.subscriptionFeeSinglePrint.tax = fee.tax;
                    this.subscriptionFeeSinglePrint.discount = fee.discount;
                    this.subscriptionFeeSinglePrint.taxRate = fee.taxRate;
                    this.subscriptionFeeSinglePrint.taxCalculationType = fee.taxType;
                    setTimeout(() => {
                        this.singleReceiptPrintComponent.initiatePrintInvoice(this.subscriptionFeeSinglePrint);
                    }, 300);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    getSingleSubscriptionFeeEmail(id, start, due) {
        this.appServiceManager.get("subscriptionFee/" + id + "/feeBySubscriptionId").subscribe(
            (res) => {
                if (res) {
                    console.log(res);
                    const fee = res.response[0];
                    this.subscriptionFeeSinglePrint.invoice = fee.invoice;
                    this.subscriptionFeeSinglePrint.createdDate = new Date(fee.date);
                    this.subscriptionFeeSinglePrint.startDate = new Date(start);
                    this.subscriptionFeeSinglePrint.endDate = new Date(due);
                    this.subscriptionFeeSinglePrint.membershipNumber = fee.subscriberMembership;
                    this.subscriptionFeeSinglePrint.memberName = fee.subscriberName;
                    this.subscriptionFeeSinglePrint.feeType = fee.status;
                    this.subscriptionFeeSinglePrint.fee = fee.pay;
                    this.subscriptionFeeSinglePrint.tax = fee.tax;
                    this.subscriptionFeeSinglePrint.discount = fee.discount;
                    this.subscriptionFeeSinglePrint.taxRate = fee.taxRate;
                    this.subscriptionFeeSinglePrint.taxCalculationType = fee.taxType;
                    setTimeout(() => {
                        this.singleReceiptEmailComponent.openSingleReceiptEmailConfirmation(this.subscriptionFeeSinglePrint, due);
                    }, 300);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    getOlderDateInLoopOfSubscriptions(previous, current) {
        let previousDateObj = new Date(previous);
        previousDateObj.setHours(0,0,0,0);
        let currentDate = new Date(current);
        currentDate.setHours(0,0,0,0);
        if(currentDate < previousDateObj) {
            return true;
        }
        return false;
    }

    getDueDateInLoopOfSubscriptions(previous, current) {
        let previousDateObj = new Date(previous);
        previousDateObj.setHours(0,0,0,0);
        let currentDate = new Date(current);
        currentDate.setHours(0,0,0,0);
        if(currentDate > previousDateObj) {
            return true;
        }
        return false;
    }

    closeAddSubscriptionDialog() {
        this.subscriptionsDetailView = false;
    }

    getSubscriptionStatus(dueDate) {
        let dueDateObj = new Date(dueDate);
        dueDateObj.setHours(0,0,0,0);
        let dateNow = new Date();
        dateNow.setHours(0,0,0,0);
        if(dueDateObj < dateNow) {
            return "Expired";
        }
        return "Active";
    }

    getSubscriptionConductedSessions(subscriptionId) {
        console.log(subscriptionId);
        return 0;
    }

    getAllServices() {
        this.SubscriptionPopupLoading = true;
      this.appServiceManager.get("services/" + this.user.branch).subscribe(
        (res) => {
          if (res) {
            this.allSubscriptions = [];
            this.services = res.response;
            if(this.subscriptionsDetailView) {
                this.prepareServiceDetailData(this.serviceInDetailView);
            }
            const grouped = this.subscriptions.reduce(
                (result: any, currentValue: any) => {
                    (result[currentValue['serviceId']] = result[currentValue['serviceId']] || []).push(currentValue);
                    return result;
                }, {});

            let servicesInSubscription = Object.keys(grouped);
            servicesInSubscription.forEach(servicesId => {
                let serviceObj = this.services.filter(s => s._id == servicesId)[0];
                let existingServiceObj = this.subscribedServices.filter(s => s._id == servicesId);
                if(existingServiceObj.length == 0){
                    this.subscribedServices.push(serviceObj);
                }
            });

            res.response.forEach(service => {
                let serviceObj = {
                    name: service.name,
                    id: service._id,
                    trainers: []
                };

                if(service.type === 'trainingService'){
                service.trainers.forEach(trainer => {
                    const trainerDb = this.Trainers.filter(t => t._id === trainer.userId)[0];

                    if(trainerDb === null || trainerDb === undefined) {
                        return;
                    }
                    if(trainerDb.fees === null || trainerDb.fees === undefined || trainerDb.fees.length <= 0) {
                        return;
                    }
                    let trainerObj = {
                        name : trainerDb.name,

                        fees:[]
                    }

                    trainerDb.fees.forEach(fee => {
                        if(fee === null || fee === undefined) {
                            return;
                        }
                        if(fee.services == null || fee.services == undefined || fee.services.length == 0) {
                            return;
                        }
                        let check = fee.services.filter(s => s == service._id);
                        if(check.length == 0 ) {
                            return;
                        }
                        let feeObj = {
                            feeName: fee.title,
                            feeId: fee._id,
                            trainerId: trainerDb._id,
                            serviceId: service._id
                        };
                        trainerObj.fees.push(feeObj);
                    });
                    serviceObj.trainers.push(trainerObj);
                    console.log("serviceObj.trainers",serviceObj.trainers);
                });
             }else if(service.type === 'selfService'){
                 let EmptyObj = {
                     name: 'Package',
                     fees:[]
                 }
                serviceObj.trainers.push(EmptyObj);
                service.packages.forEach(Packages => {
                    let PackagesObj = {
                        name: Packages.name,
                        fees:[]
                    }
                        let eachPackageObj = {
                            feeName: Packages.name,
                            feeId: Packages._id,
                            serviceId: service._id
                        };
                        EmptyObj.fees.push(eachPackageObj);

                });
             }

                this.allSubscriptions.push(serviceObj);
            });

            console.log("this.allSubscriptions",this.allSubscriptions);
            console.log(res.response);
            this.SubscriptionPopupLoading = false;
          } else {
            this.SubscriptionPopupLoading = false;
          }
        },
        (error) => {
          this.SubscriptionPopupLoading = false;
          console.log(error);
        }
      );
    }

    deleteThisSubscription(subscriptionId) {
        this.confirmationService.confirm({
            message: "Are you sure you want to delete subscription? All the fees, sessions related to the subscription will be deleted.",
            accept: () => {
                this.deleteSubscription(subscriptionId);
            },
        });
    }

    deleteSubscription(subscriptionId) {
        this.appServiceManager.delete("subscriptions/"+subscriptionId)
        .subscribe((res) => {
            console.log(res);
            this.closeAddSubscriptionDialog();
            this.subscribedServices = [];
            this.getAllSubscriptions();
        },
        (error) => {
            console.log(error);
        })
    }

    initObjects() {
        this.member = new IMember();
        this.company = new ICompany();
        this.branch = new IBranch();
        this.freezeMemberDetails = [];
        this.member.contactDetail = new IMemberContact();
        this.member.emergencyContact = new IMemberEmergencyContact();
        this.member.freezeDetail = new IMemberFreezeDetail();
        this.member.emergencyContact.medicalDetail = "";
        this.member.contactDetail.address = new IAddress();
        this.member.settings = new ISettings();
        this.member.customerstrainer = new Customerstrainer();
        this.fund = new IMemberFeeDetails();
        this.fundInvoice = new IMemberFeeDetails();
        this.member.customerstrainer.totalFees = "0";
        this.array = new Array("1", "2");
        this.difference = 0;
        this.fund.pay = 0;
        this.packageFee = 0;
        this.packageRegistrationFee = 0;
        this.fund.discountAmount = 0;


        this.feealreadypaid = false;
        this.feegreater = false;
        this.printAllFeeTotal = {
            totalRegistationFee: 0,
            totalDiscountFee: 0,
            totalFeeTax: 0,
            totalTrainerFee: 0,
            totalMonthlyFee: 0,
            totalFineFee: 0,
            feeGrandTotal: 0,
        }
        this.options = [
            { label: "Select Fee Type", value: null },
            { label: "Fine Fee", value: "Fine Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];
        this.fund.status = "Monthly Fee - Paid";
        this.statusOptions = [
            { label: "Select Fee Type", value: null },
            { label: "All", value: "All" },
            { label: "Fine Fee", value: "Fine Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];

        this.months = [
            { label: "Select Month", value: null },
            { label: "January", value: 1 },
            { label: "Febuary", value: 2 },
            { label: "March", value: 3 },
            { label: "April", value: 4 },
            { label: "May", value: 5 },
            { label: "June", value: 6 },
            { label: "July", value: 7 },
            { label: "August", value: 8 },
            { label: "September", value: 9 },
            { label: "October", value: 10 },
            { label: "November", value: 11 },
            { label: "December", value: 12 },
        ];
        this.years = [
            { label: "Select Year", value: null },
            { label: "2015", value: 2015 },
            { label: "2016", value: 2016 },
            { label: "2017", value: 2017 },
            { label: "2018", value: 2018 },
            { label: "2019", value: 2019 },
            { label: "2020", value: 2020 },
            { label: "2021", value: 2021 },
            { label: "2022", value: 2022 },
            { label: "2023", value: 2023 },
            { label: "2024", value: 2024 },
            { label: "2025", value: 2025 },
            { label: "2026", value: 2026 },
            { label: "2027", value: 2027 },
            { label: "2028", value: 2028 },
            { label: "2029", value: 2029 },
            { label: "2030", value: 2030 },
            { label: "2031", value: 2031 },
            { label: "2032", value: 2032 },
            { label: "2033", value: 2033 },
            { label: "2034", value: 2034 },
            { label: "2035", value: 2035 },
            { label: "2036", value: 2036 },
            { label: "2037", value: 2037 },
            { label: "2038", value: 2038 },
            { label: "2039", value: 2039 },
            { label: "2040", value: 2040 },
        ];
        this.trainerOptions = [{ label: "Select Trainer", value: null }];
        this.packagesDropDown = [{ label: "Select Package", value: null }];
    }
    onIdentityTypeChange() {
        if (this.selectedIdentityType == "Passport" ) {
            this.errorMessage = this.setLabel("passport8DigitsErrorLabel");

        } else {
            this.errorMessage = this.setLabel("cNIC13DigitsErrorLabel");
        }
    }
    onCNICChange(){
        this.errorMessage = "";
    }
    getBranchByID() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            this.member.password = this.branch.appPassword;
        }

        if(!this.branch){
            this.appServiceManager.get("branches/" + this.user.branch).subscribe(
                (res: any) => {
                    if (res) {
                        this.member.password = res.appPassword;
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "Something Went Wrong",
                        });
                    }
                },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );

        }
    }

    getPackages() {
        this.packages = [];
        this.loading = true;
        this.appServiceManager
            .get(
                "packagesBuilder/company/" +
                this.user.company +
                "/branch/" +
                this.user.branch
            )
            .subscribe(
                (res: IPackageBuider[]) => {
                    this.packages = res;
                    res= res.filter(x => !x.isDelete);
                    this.setPackages(res);
                    this.packageToShowName = res;
                    this.loading = false;
                },
                (error: any) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }

    setPackages(packages) {
        this.packagesDropDown = [{ label: "Select Package", value: null }];
        packages.map((data: any) => this.packagesDropDown.push({ label: data.packageName, value: data._id }));
        this.customerPackageId = this.member.packageId;
    }

    togglePasswordType1() {
        if (this.passwordType1 === "password") {
            this.passwordType1 = "text";
        } else {
            this.passwordType1 = "password";
        }
    }

    togglePasswordType2() {
        if (this.passwordType2 === "password") {
            this.passwordType2 = "text";
        } else {
            this.passwordType2 = "password";
        }
    }
    togglePasswordType3() {
        if (this.passwordType3 === "password") {
            this.passwordType3 = "text";
        } else {
            this.passwordType3 = "password";
        }
    }
    // feeChange() {
    //     this.showTrainerFeeError = false;
    //     this.showRegistrationFeeError = false;
    //     this.showMonthlyFeeError = false;
    //     this.checkFeePaid(this.fund.month, this.fund.year);
    //     this.array[0] = this.member._id;
    //     this.array[1] = this.fund;
    //     this.member.monthFee = this.packageFee;
    //     this.trainerNotSelected = false;
    //     if (this.fund.status === "Trainer Fee - Paid") {
    //         this.appServiceManager
    //             .post("customers/specificTrainermonthFee", this.array)
    //             .subscribe(
    //                 (response) => {
    //                     this.difference =
    //                         parseInt(this.member.customerstrainer.totalFees) -
    //                         response;

    //                     if (this.member.question3 === 'YES') {
    //                         if (parseInt(this.member.customerstrainer.totalFees) != 0) {
    //                             if (this.difference <= 0) {
    //                                 this.fund.pay = this.difference;
    //                                 if (this.fund.pay < 0) {
    //                                     this.fund.pay = 0;
    //                                 }
    //                                 let pay = parseInt(this.member.monthFee);
    //                                 let percentagePaid = pay / parseInt(this.member.monthFee) * 100;
    //                                 let numberOfDays: any = '';
    //                                 if (pay != parseInt(this.member.monthFee)) {
    //                                     numberOfDays = (percentagePaid / 100) * 30;
    //                                 } else {
    //                                     numberOfDays = moment(this.member.customerstrainer.dueDate); // Assuming a month is 30 days for other cases.
    //                                     numberOfDays = numberOfDays.daysInMonth();
    //                                     console.log("numberOfDays", numberOfDays)
    //                                 }
    //                                 numberOfDays = Math.floor(numberOfDays);

    //                                 let futureDateTrainer = moment(this.member.customerstrainer.dueDate).add(numberOfDays, 'days').toISOString();
    //                                 this.fund.dueDate = new Date(futureDateTrainer);
    //                                 //this.fund.day = new Date(this.member.customerstrainer.dueDate).getDate().toString();
    //                                 if (this.isFeeMessageVisible && !this.monthlyPaid) {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Trainer fee already paid.Please check monthly fee.",
    //                                     });
    //                                 }
    //                                 else if (this.monthlyPaid && this.registrationPaid) {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Fee already paid.",
    //                                     });
    //                                 }

    //                                 this.feealreadypaid = true;
    //                             } else {
    //                                 this.fund.pay = this.difference;
    //                                 if (this.fund.pay < 0) {
    //                                     this.fund.pay = 0;
    //                                 }
    //                                 this.fundInvoice.pay = this.difference;
    //                                 let pay = parseInt(this.member.monthFee);
    //                                 let percentagePaid = pay / parseInt(this.member.monthFee) * 100;
    //                                 let numberOfDays: any = '';
    //                                 if (pay != parseInt(this.member.monthFee)) {
    //                                     numberOfDays = (percentagePaid / 100) * 30;
    //                                 } else {
    //                                     numberOfDays = moment(this.member.customerstrainer.dueDate); // Assuming a month is 30 days for other cases.
    //                                     numberOfDays = numberOfDays.daysInMonth();
    //                                     console.log("numberOfDays", numberOfDays)
    //                                 }
    //                                 numberOfDays = Math.floor(numberOfDays);

    //                                 let futureDateTrainer = moment(this.member.customerstrainer.dueDate).add(numberOfDays, 'days').toISOString();
    //                                 this.fund.dueDate = new Date(futureDateTrainer);
    //                                 //this.fund.dueDate = this.member.customerstrainer.dueDate;
    //                                 //this.fund.day = new Date(this.member.customerstrainer.dueDate).getDate().toString();
    //                                 this.feealreadypaid = false;
    //                             }
    //                         }

    //                     } else {
    //                         this.fund.pay = this.difference;
    //                         if (this.fund.pay < 0) {
    //                             this.fund.pay = 0;
    //                         }
    //                         this.feealreadypaid = false;
    //                         this.trainerNotSelected = true;
    //                     }
    //                 },
    //                 (error) => {
    //                     this.loading = false;
    //                     this.messageService.clear();
    //                     this.messageService.add({
    //                         severity: "error",
    //                         summary: "Error Message",
    //                         detail: error,
    //                     });
    //                 }
    //             );
    //     } else if (this.fund.status === "Registration Fee - Paid") {
    //         this.appServiceManager
    //             .post("customers/specificregistrationFee", this.array)
    //             .subscribe(
    //                 (response) => {
    //                     this.member.registerationFee = this.packageRegistrationFee;
    //                     this.difference =
    //                         parseInt(this.member.registerationFee) -
    //                         response;
    //                     if (this.difference <= 0) {
    //                         this.fund.pay = this.difference;
    //                         //this.fund.dueDate = this.member.settings.dueDate;
    //                         //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                         if (this.isFeeMessageVisible && !this.monthlyPaid && !this.trainerPaid && this.member.question3 == "YES") {
    //                             this.messageService.clear();
    //                             this.messageService.add({
    //                                 severity: "error",
    //                                 summary: "Registration fee already paid.Please check monthly fee and trainer fee.",
    //                             });
    //                         } else if (this.monthlyPaid && this.member.question3 == "YES" && !this.trainerPaid) {
    //                             this.messageService.clear();
    //                             this.messageService.add({
    //                                 severity: "error",
    //                                 summary: "Registration fee already paid.Please check trainer fee.",
    //                             });
    //                         } else if (!this.monthlyPaid && this.member.question3 == "YES" && this.trainerPaid) {
    //                             this.messageService.clear();
    //                             this.messageService.add({
    //                                 severity: "error",
    //                                 summary: "Registration Fee already paid.Please check monthly fee.",
    //                             });
    //                         } else if (this.monthlyPaid && this.member.question3 == "YES" && this.trainerPaid) {
    //                             this.messageService.clear();
    //                             this.messageService.add({
    //                                 severity: "error",
    //                                 summary: "Fee already paid.",
    //                             });
    //                         } else if (this.member.question3 == "NO" && this.monthlyPaid) {
    //                             this.messageService.clear();
    //                             this.messageService.add({
    //                                 severity: "error",
    //                                 summary: "Fee already paid.",
    //                             });
    //                         }
    //                         this.feealreadypaid = true;
    //                     } else {
    //                         this.fund.pay = this.difference;
    //                         this.fundInvoice.pay = this.difference;
    //                         //this.fund.dueDate = this.member.settings.dueDate;
    //                         //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                         this.feealreadypaid = false;
    //                     }
    //                 },
    //                 (error) => {
    //                     this.loading = false;
    //                     this.messageService.clear();
    //                     this.messageService.add({
    //                         severity: "error",
    //                         summary: "Error Message",
    //                         detail: error,
    //                     });
    //                 }
    //             );
    //     } else if (this.fund.status === "Monthly Fee - Paid") {
    //         if (parseInt(this.member.monthFee) >= 0) {
    //             this.appServiceManager
    //                 .post("customers/specificmonthFee", this.array)
    //                 .subscribe(
    //                     (response) => {
    //                         if (this.packageFee == "0") {
    //                             this.member.monthFee = this.packageFee;
    //                             this.difference =
    //                                 parseInt(this.member.monthFee) - response;

    //                             this.fund.pay = this.difference;
    //                             if (this.fund.pay < 0) {
    //                                 this.fund.pay = 0;
    //                             }
    //                             //this.fund.dueDate = this.member.settings.dueDate;
    //                             //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                             if (this.isFeeMessageVisible) {
    //                                 if (this.member.question3 == "YES" && !this.trainerPaid) {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Please check trainer fee.",
    //                                     });
    //                                 } else if (this.member.question3 == "YES" && this.trainerPaid) {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Fee already paid.",
    //                                     });
    //                                 } else if (this.member.question3 == "NO") {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Fee already paid.",
    //                                     });
    //                                 }
    //                             }
    //                             this.fund.pay = this.difference;
    //                             this.fund.pay *= this.numOfMonths;
    //                             if (this.fund.pay < 0) {
    //                                 this.fund.pay = 0;
    //                             }
    //                             this.fundInvoice.pay = this.difference;
    //                             //this.fund.dueDate = this.member.settings.dueDate;
    //                             //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                             this.feealreadypaid = false;

    //                         }
    //                         else {
    //                             this.member.monthFee = this.packageFee;
    //                             this.difference =
    //                                 parseInt(this.member.monthFee) - response;
    //                             if (this.difference <= 0) {
    //                                 this.fund.pay = this.difference;
    //                                 if (this.fund.pay < 0) {
    //                                     this.fund.pay = 0;
    //                                 }
    //                                 //this.fund.dueDate = this.member.settings.dueDate;
    //                                 //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                                 if (this.isFeeMessageVisible) {
    //                                     if (!this.registrationPaid) {
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "error",
    //                                             summary: "Monthly fee already paid.Please check registration fee.",
    //                                         });
    //                                     }
    //                                     else if (this.member.question3 == "YES" && !this.registrationPaid && !this.trainerPaid) {
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "error",
    //                                             summary: "Monthly fee already paid.Please check registration fee and trainer fee.",
    //                                         });
    //                                     } else if (!this.trainerPaid && this.member.question3 == "YES") {
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "error",
    //                                             summary: "Monthly fee already paid.Please check trainer fee.",
    //                                         });
    //                                     } else if (this.registrationPaid && this.member.question3 == "YES" && this.trainerPaid) {
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "error",
    //                                             summary: "Fee already paid.",
    //                                         });
    //                                     } else if (this.member.question3 == "NO") {
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "error",
    //                                             summary: "Fee already paid.",
    //                                         });
    //                                     }
    //                                 }
    //                                 this.feealreadypaid = true;
    //                             } else {
    //                                 this.fund.pay = this.difference;
    //                                 this.fund.pay *= this.numOfMonths;
    //                                 if (this.fund.pay < 0) {
    //                                     this.fund.pay = 0;
    //                                 }
    //                                 this.fundInvoice.pay = this.difference;
    //                                 //this.fund.dueDate = this.member.settings.dueDate;
    //                                 //this.fund.day = new Date(this.member.settings.dueDate).getDate().toString();
    //                                 this.feealreadypaid = false;
    //                             }
    //                         }
    //                     },
    //                     (error) => {
    //                         this.loading = false;
    //                         this.messageService.clear();
    //                         this.messageService.add({
    //                             severity: "error",
    //                             summary: "Error Message",
    //                             detail: error,
    //                         });
    //                     }
    //                 );
    //         } else {
    //             this.messageService.clear();
    //             this.messageService.add({
    //                 severity: "error",
    //                 summary: "Error Message",
    //                 detail: "Month Fee should be a positive value",
    //             });
    //         }

    //     } else if (this.fund.status === "Fine Fee - Paid") {
    //         this.fund.pay = 0;
    //         this.feealreadypaid = false;
    //         this.fund.dueDate = new Date();
    //         this.fund.day = new Date().getDate().toString();
    //     } else {
    //         this.fund.pay = 0;
    //     }
    // }

    calculateTotalForSinglePrint(fee, tax, discount,taxType) {
        if(tax === undefined || tax === null) {
            tax = 0;
        }
        if(discount === undefined || discount === null) {
            discount = 0;
        }
        if(taxType === 'WITH_TAX') {
            let total= (parseFloat(fee) + parseFloat(tax)) - parseFloat(discount);
            return total.toLocaleString('en-US' ,{minimumFractionDigits:0});
        }
        else {
            let total= parseFloat(fee) - parseFloat(discount);
            return total.toLocaleString('en-US' ,{minimumFractionDigits:0});

        }
    }

    dropdownChange() {
        var data = this.Trainers.filter(
            (x) => x._id === this.member.customerstrainer.trainerId
        );
        if (data.length > 0) {
            this.member.customerstrainer.trainerId = data[0]._id;
            this.member.customerstrainer.name = data[0].name;
            this.member.customerstrainer.totalFees = data[0].totalFees
                ? data[0].totalFees
                : 0;
            this.member.customerstrainer.trainerShare = data[0].trainerShare
                ? data[0].trainerShare
                : 0;
            this.member.customerstrainer.gymShare = data[0].gymShare
                ? data[0].gymShare
                : 0;
        }
    }
    // checkfeegreater() {
    //     //this.previousDueDate=this.member.settings.dueDate
    //     // let percentagePaid = this.fund.pay / parseInt(this.member.monthFee) * 100;
    //     // let numberOfDays :any = '';
    //     // if (this.fund.pay != parseInt(this.member.monthFee)) {
    //     //      numberOfDays = (percentagePaid / 100) * 30;
    //     // } else {
    //     //     numberOfDays = moment(this.member.settings.dueDate); // Assuming a month is 30 days for other cases.
    //     //     numberOfDays = numberOfDays.daysInMonth();
    //     //     console.log("numberOfDays",numberOfDays)
    //     // }
    //     // numberOfDays = Math.floor(numberOfDays);
    //     // let futureDate = moment(this.member.settings.dueDate).add(numberOfDays, 'days').toISOString();
    //     // this.fund.dueDate = new Date(futureDate);
    //     // if (this.fund.status === 'Fine Fee - Paid') {
    //     //     this.feegreater = false;
    //     // }
    //     // } else if (this.fund.pay > this.difference) {
    //     //     this.messageService.clear();
    //     //     this.messageService.add({
    //     //         severity: "error",
    //     //         summary: "You cannot pay more than actual fees",
    //     //     });
    //     //     this.feegreater = true;
    //     // } else {
    //     //     this.feegreater = false;
    //     // }
    // }
    getTrainers() {
        this.Trainers = [];
        this.loading = true;
        this.appServiceManager.get('users/company/' + this.user.company + '/branch/' + this.user.branch + '/trainers').subscribe(
            (res) => {
                if (res.length > 0) {
                    this.setTrainerData(res);
                } else {
                    this.Trainers = [];
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Record Found",
                    });
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }
    clearPasswordFeilds() {
        this.newPassword = null;
        this.newConfirmPassword = null;
        this.passwordType1 = "password";
    }
    setTrainerData(Trainers) {
        var sortedTrainers = [];
        for (var i = 0; i < Trainers.length; i++) {
            if (Trainers[i].isDelete == false) {
                sortedTrainers.push(Trainers[i]);
            }
        }
        sortedTrainers.sort(function (a, b) {
            if (
                a.name.substring(0, 1).toLowerCase() <
                b.name.substring(0, 1).toLowerCase()
            ) {
                return -1;
            } else if (
                a.name.substring(0, 1).toLowerCase() >
                b.name.substring(0, 1).toLowerCase()
            ) {
                return 1;
            }
            return 0;
        });
        for (var i = 0; i < Trainers.length; i++) {
            if (Trainers[i].isDelete == true) {
                sortedTrainers.push(Trainers[i]);
            }
        }
        this.Trainers = sortedTrainers;
        this.Trainers = [...this.Trainers];
        this.Trainers.forEach((trainer) => {
            this.trainerOptions.push({
                label: trainer.name,
                value: trainer._id,
            });
        });
    }
    getCompany() {
        this.company = AuthService.getLoggedInCompanyBranch();
        if(!this.company){
        this.appServiceManager.get("companies/" + this.user.company).subscribe(
            (res) => {
                if (res) {
                    this.company = res;
                } else {
                    this.company = new ICompany();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }
            },
            (error) => {
                this.company = new ICompany();
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
     }
    }
    // Custom comparison function based on day, month, and year
    compareByDate(a, b) {
        const dateA: any = new Date(`${a.year}-${a.month}-${a.day}`);
        const dateB: any = new Date(`${b.year}-${b.month}-${b.day}`);
        return dateB - dateA;
    }
    getPackagesByID() {
        this.loading = true;
        console.log("this.member.packageId", this.member.packageId)
        this.appServiceManager
            .get(
                "packagesBuilder/" +
                this.member.packageId
            )
            .subscribe(
                (res) => {
                    this.packageName = res.packageName;
                    this.numOfMonths = res.noOfMonths;
                    this.packageFee = res.packageFee;
                    this.member.monthFee = this.packageFee;
                    this.numberOfMembers = res.noOfMembers;
                    this.packageRegistrationFee = res.registerationFee;
                    if (this.allowDialog) {
                        // this.showDialog();
                        this.allowDialog = false;
                        this.isDialogVisible = true;
                    }
                    console.log("packageName", this.packageName)
                    this.loading = false;
                },
                (error: any) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );

    }
    getCustomerByID() {
        this.appServiceManager.get("customers/" + this.memberID).subscribe(
            (res: any) => {
                if (res) {
                    this.member = res;
                    this.selectedIdentityType = 'CNIC';
                    if(this.member.CNIC){
                        if(this.member.CNIC.length !== 13){
                            this.selectedIdentityType = 'Passport';
                        }else{
                            this.selectedIdentityType = 'CNIC';
                        }
                    }
                     // Check the CNIC value
                     if (/^\d{13}$/.test(this.member.CNIC)) {
                        this.selectedIdentityType = 'CNIC'; // Exactly 13 digits
                    // } else if (/^[A-Za-z0-9]{1,9}$/.test(this.member.CNIC)) {
                    } else if (/^[A-Za-z0-9]$/.test(this.member.CNIC)) {
                        this.selectedIdentityType = 'Passport'; // 9 or fewer alphanumeric characters
                    }
                    this.member.oldDate = this.member.settings.dueDate;
                    this.member.oldValue = this.member.packageName;
                    this.member.currentUserData = this.currentUserData;
                    let currentDate=new Date();
                    let joinDate=new Date(this.member.joiningDate);
                    if (joinDate.getMonth() === currentDate.getMonth() && joinDate.getFullYear() === currentDate.getFullYear()) {
                        this.welcomeMsg = true;
                      } else {
                        this.welcomeMsg = false;
                      }
                    this.dbEmailIfCustomerHAve = this.member.email && this.member.email.length > 0 ? this.member.email : undefined;
                    this.getCustomerFees();
                    this.getPackagesByID();
                    this.validateMember(res);
                    this.setDate(res);
                    this.getFreezeReport();
                    this.getAllSubscriptions();
                    this.breadcrumbService.setItems([
                        { label: "Member Management" },
                        { label: "All Members", routerLink: "/members" },
                        { label: this.member.name },
                    ]);
                    if (!this.member.password) {
                        this.getBranchByID();
                    }
                    //this.member.profile = this.config.Server + this.member.profile;
                    this.getCompany();
                    this.calculateTotal();
                    if (res.customerstrainer.name)
                        this.memberTrainer = res.customerstrainer.name;
                    else
                        this.memberTrainer = "Not Assigned";
                    if (this.openFeeDialog === "true") {
                        this.allowDialog = true;
                        // this.showDialog();
                    }
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }
            },
            (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }
    getCustomerFees() {
        this.loading = true;
        this.appServiceManager
        .get("customerFees/customer/"  + this.memberID).subscribe(
            (res: any) => {
              if (res.length > 0) {
                this.customerFees = res.reverse();
                this.feeDetailsSource = JSON.stringify(
                    this.customerFees
                  );
                this.getTotalForAllReciptPrint();

                this.calculateTotal();
              } else {
                this.messageService.clear();
                this.messageService.add({
                  severity: "info",
                  summary: "Info Message",
                  detail: "No Record Found",
                });
              }
              this.loading = false;
            },
            (error) => {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error.error.message,
              });
            }
          );
      }
    // checkFeePaid(month: any, year: any) {
    //     this.getCustomerByID();

    //     this.registrationPaid = false;
    //     this.monthlyPaid = false;
    //     this.trainerPaid = false;

    //     // Check if there is at least one entry with 'Registration Fee - Paid'
    //     const hasRegistrationFeePaid = this.member.feeDetails.some((fee) => {
    //         return fee.status === 'Registration Fee - Paid';
    //     });

    //     if (hasRegistrationFeePaid) {
    //         this.registrationPaid = true;
    //     }

    //     for (const fee of this.member.feeDetails) {
    //         if (fee.month == month && fee.year == year) {
    //             if (fee.status == 'Monthly Fee - Paid') {
    //                 this.monthlyPaid = true;
    //             } else if (this.member.question3 == 'YES' && fee.status == 'Trainer Fee - Paid') {
    //                 this.trainerPaid = true;customerFees
    //             }
    //         }
    //     }
    // }

    printAllZeroValues() {
        this.printAllFeeTotal.totalRegistationFee = 0;
        this.printAllFeeTotal.totalDiscountFee = 0;
        this.printAllFeeTotal.totalFeeTax= 0;
        this.printAllFeeTotal.grandTotalFeeTax= 0;
        this.printAllFeeTotal.totalTrainerFee = 0;
        this.printAllFeeTotal.totalMonthlyFee = 0;
        this.printAllFeeTotal.totalFineFee = 0;
        this.printAllFeeTotal.feeGrandTotal = 0;
    }

    getTotalForAllReciptPrint() {
        let memberFeeDetails = [];
        this.printAllZeroValues();
        memberFeeDetails = JSON.parse(this.feeDetailsSource);
        memberFeeDetails.map(memberFee => {
            if (memberFee.status === "Registration Fee - Paid") {
                this.printAllFeeTotal.totalRegistationFee += parseFloat(memberFee.pay);
            }
            else if (memberFee.status === "Trainer Fee - Paid") {
                this.printAllFeeTotal.totalTrainerFee += parseFloat(memberFee.pay);
            }
            else if (memberFee.status === "Monthly Fee - Paid") {
                this.printAllFeeTotal.totalMonthlyFee += parseFloat(memberFee.pay);
            }
            else if (memberFee.status === "Fine Fee - Paid") {
                this.printAllFeeTotal.totalFineFee += parseFloat(memberFee.pay);
            }
            if (memberFee.tax !== undefined && memberFee.tax !== null) {
                if (memberFee.taxCalculationType !== "INCLUDING_TAX")
                    this.printAllFeeTotal.grandTotalFeeTax += parseFloat(memberFee.tax);
                this.printAllFeeTotal.totalFeeTax += parseFloat(memberFee.tax);
            }
            this.printAllFeeTotal.totalDiscountFee += parseFloat(memberFee.discount);
            this.printAllFeeTotal.feeGrandTotal += parseFloat(memberFee.pay);
        });

        // Round final results to integers
        this.printAllFeeTotal.totalRegistationFee = Math.round(this.printAllFeeTotal.totalRegistationFee);
        this.printAllFeeTotal.totalTrainerFee = Math.round(this.printAllFeeTotal.totalTrainerFee);
        this.printAllFeeTotal.totalMonthlyFee = Math.round(this.printAllFeeTotal.totalMonthlyFee);
        this.printAllFeeTotal.totalFineFee = Math.round(this.printAllFeeTotal.totalFineFee);
        this.printAllFeeTotal.grandTotalFeeTax = Math.round(this.printAllFeeTotal.grandTotalFeeTax);
        this.printAllFeeTotal.totalFeeTax = Math.round(this.printAllFeeTotal.totalFeeTax);
        this.printAllFeeTotal.totalDiscountFee = Math.round(this.printAllFeeTotal.totalDiscountFee);
        this.printAllFeeTotal.feeGrandTotal = Math.round(this.printAllFeeTotal.feeGrandTotal);
    }

    // print report Api Get
    getFreezeReport() {
        this.freezeMemberDetails = [];
        this.appServiceManager
            .put("customers/freezeDetailsbyIdCompanyIdBranchId/" + this.member.tagNumber, this.member)
            .subscribe(
                (res: any) => {
                    if (res) {
                        this.freezeMemberDetails = res;
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "Something Went Wrong",
                        });
                    }
                },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }

    validateMember(res) {
        if (
            this.member.settings === null ||
            this.member.settings === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (
            this.member.settings.dueDate === null ||
            this.member.settings.dueDate === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (res.settings.dueDate === "null") {
            this.member.settings.dueDate = null;
        } else {
            var dueDate = JSON.stringify(res.settings.dueDate);
            var DD = JSON.parse(dueDate).split("/");
            if (DD.length === 1) {
                this.member.settings.dueDate = new Date(DD);
            } else {
                var newDDate = DD[1] + "/" + DD[0] + "/" + DD[2];
                if (newDDate) {
                    this.member.settings.dueDate = new Date(newDDate);
                }
            }
        }
        if (
            this.member.customerstrainer === undefined ||
            this.member.customerstrainer === null
        ) {
            this.member.customerstrainer = new Customerstrainer();
            this.member.customerstrainer.name = "";
            this.member.customerstrainer.trainerId = "";
            this.member.customerstrainer.totalFees = "";
        }
        if (
            this.member.emergencyContact === null ||
            this.member.emergencyContact === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        }
        if (this.member.contactDetail.address) {
            if (
                this.member.contactDetail.address.street === null &&
                this.member.contactDetail.address.street === ""
            ) {
                this.member.contactDetail.address.street = "";
            }
            if (
                this.member.contactDetail.address.city === null &&
                this.member.contactDetail.address.city === ""
            ) {
                this.member.contactDetail.address.city = "";
            }
            if (
                this.member.contactDetail.address.country === null &&
                this.member.contactDetail.address.country === ""
            ) {
                this.member.contactDetail.address.country = "";
            }
            if (
                this.member.contactDetail.address.state === null &&
                this.member.contactDetail.address.state === ""
            ) {
                this.member.contactDetail.address.state = "";
            }
            if (
                this.member.contactDetail.address.zipCode === null &&
                this.member.contactDetail.address.zipCode === ""
            ) {
                this.member.contactDetail.address.zipCode = "";
            }
            if (
                this.member.contactDetail.address.town === null &&
                this.member.contactDetail.address.town === ""
            ) {
                this.member.contactDetail.address.town = "";
            }
        } else {
            this.member.contactDetail.address = new IAddress();
        }
    }

    validateMemberTrainer() {
        if (
            this.member.question3 === "YES" &&
            parseInt(this.member.customerstrainer.totalFees) >= 0 &&
            this.member.customerstrainer.dueDate != null &&
            this.member.customerstrainer.trainerId != null
        ) {
            return true;
        } else if (this.member.question3 === "NO") {
            return true;
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please Complete Fields Properly",
            });
            return false;
        }
    }

    onDueDateChange(newDate: Date) {
        this.updateMemberSettingFlag = true;
    }
    openUpdateBodySpecDialog(bodySpec: any) {
        this.showBodySpecPopup=true
  this.bodySpec = { ...bodySpec }; // clone to avoid direct mutation
  this.updateBodySpecDialogVisible = true;
}
    getBodySpecification() {
        if (!this.memberID) {
            this.getBodySpecs = [];
            return;
        }
        this.appServiceManager.get('customerVitals/getBodySpecification/' + this.memberID).subscribe(
            (res) => {
                if (res && res.data) {
                    this.getBodySpecs = res.data;
                } else {
                    this.getBodySpecs = [];
                }
            },
            (error) => {
                this.getBodySpecs = [];
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Failed to fetch Body Specification."
                });
            }
        );
    }
    openUpdateBodySpecPopup(entry: any) {
        this.showBodySpecPopup = true
        this.bodySpec = {
            totalBodyWater: entry.totalBodyWater ?? null,
            protein: entry.protein ?? null,
            mineral: entry.mineral ?? null,
            bodyFatMass: entry.bodyFatMass ?? null,
            weight: entry.weight ?? null,
            sMM: entry.sMM ?? null,
            bMI: entry.bMI ?? null,
            pBF: entry.pBF ?? null,
            waistHipRatio: entry.waistHipRatio ?? null,
            visceralFatLevel: entry.visceralFatLevel ?? null,
            height: entry.height ?? null,
            _id: entry._id ?? null,
        };
    }

    updateBodySpec(bodySpec: any) {
        const updatedData = {
            ...this.bodySpec,
            memberId: this.memberID,
        };
        this.appServiceManager.put("customerVitals/updateBodySpecification/" + this.memberID, updatedData).subscribe(
            (res) => {
                if (res) {
                    this.updateBodySpecDialogVisible = false;
                    this.showBodySpecPopup = false;
                    this.getBodySpecification();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Body Specification updated successfully."
                    });
                    // Optionally reset the form
                    this.bodySpec = {
                        totalBodyWater: 0,
                        protein: 0,
                        mineral: 0,
                        bodyFatMass: 0,
                        weight: 0,
                        sMM: 0,
                        bMI: 0,
                        pBF: 0,
                        waistHipRatio: 0,
                        visceralFatLevel: 0,
                        height: 0,
                        _id: 0,
                    };
                }
            },
            (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Failed to update Body Specification."
                });
            }
        );
    }
    update(form: any) {
        if (form.valid) {
            // var check1 = this.checkUserPass();
            // var check2 = this.checkPassLength();
            // if (check1) {
            console.log(this.member.CNIC);
            this.confirmationService.confirm({
                message: "Are you sure you want to update member ?",
                accept: async () => {
                    this.member.company = this.user.company;
                    this.member.branch = this.user.branch;
                    if(this.isPackageUpdated){
                        this.member.type = '';
                        const selectedPackagename = this.packagesDropDown.find(package1 => package1.value === this.member.packageId);
                        this.member.scope = 'Member';
                        this.member.initiatedFrom = 'Add Member';
                        this.member.packageName = selectedPackagename.label;
                        this.updateMemberSettingFlag = true;
                        this.isPackageUpdated = false;

                    }else{
                    this.member.type = '';
                    this.member.scope = 'Member';
                    this.member.initiatedFrom = 'Add Member';
                    this.updateMemberSettingFlag = true;
                    }

                    if (this.sessionCountChanged) {
                        this.member.customerstrainer.remainingSessionCount = parseInt(this.member.customerstrainer.sessionCount);
                    }
                    this.member.memberSettingFlag = this.updateMemberSettingFlag;
                    if (this.member.customerstrainer.name) {
                        this.memberTrainer = this.member.customerstrainer.name;
                    }
                    else
                        this.memberTrainer = "Not Assigned";
                    this.appServiceManager
                        .put("customers/" + this.member._id, this.member)
                        .subscribe(
                            (res: any) => {
                                if (res) {
                                    if (this.sessionCountChanged) {
                                        const url = `trainingAttendance/updateSessionCount/${this.member._id}`;
                                        const body = { sessionCount: this.member.customerstrainer.sessionCount, flag: false };
                                        this.appServiceManager.put(url, body).subscribe((res: any) => {
                                            this.sessionCountChanged = false;
                                            console.log('Update successful', res);
                                        },
                                            (error) => {
                                                // Handle the error
                                                console.error('Update failed', error);
                                            }
                                        );
                                    }

                                    if (this.uploadProfile && this.member.profile) {
                                        const file = AppUtils.base64ToFile(this.uploadProfile, `${this.member.name}.png` + ":" + this.companySessionStorage + ":" + this.branchSessionStorage);
                                        this.uploadCustomerImage(file, this.member._id, true);
                                    }
                                    else if (this.oldMemberImage && !this.member.profile) {
                                        this.appServiceManager.delete(`customers/profileimages/${this.member._id}`).subscribe((res: any) => {
                                            if (res.message == "Profile image deleted successfully") {
                                                this.messageService.clear();
                                                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Profile Image Deleted Please Reload' });
                                            }
                                        });
                                    }
                                    //this.member = res.customer;
                                    this.feeDetailsSource = JSON.stringify(
                                        this.customerFees
                                    );
                                    this.validateMember(res.customer);
                                    this.fund.pay = parseInt(
                                        this.member.monthFee
                                    );
                                    this.setDate(res.customer);
                                    this.getCompany();
                                    this.calculateTotal();

                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "success",
                                        summary: "Success Message",
                                        detail: "Member Successfully Updated",
                                    });
                                    this.clearPasswordFeilds();
                                } else {
                                    this.messageService.clear();
                                    this.messageService.add({
                                        severity: "info",
                                        summary: "Info Message",
                                        detail: "Something Went Wrong",
                                    });
                                }
                            },
                            (error) => {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "error",
                                    summary: "Error Message",
                                    detail: error,
                                });
                            },
                            this.updateMemberSettingFlag = false
                        );

                },
            });
        }
        else {
            //  // Form validation error handling
            Object.keys(form.controls).forEach(controlName => {
                const control = form.controls[controlName];
                control.markAsTouched(); // Mark the control as touched to display the validation error messages
            });
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please fill the member details.",
            });
        }
        // }
    }

    checkDateOfBirth(){
        const currentDate = new Date();
        if(this.member.dateOfBirth && new Date(this.member.dateOfBirth) > currentDate){
            this.dateOfBirthError = true;
        }else{
            this.dateOfBirthError = false;
        }
    }

    checkUserPass() {
        if (this.newPassword !== "") {
            if (
                this.newPassword === this.newConfirmPassword &&
                this.newPassword.length >= 4
            ) {
                this.member.password = this.newPassword;
                return true;
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "User New Password and Confirm Password doesn't match",
                });
                return false;
            }
        }
        return true;
    }
    checkPassLength() {
        if (this.newPassword !== "") {
            if (this.newPassword.length >= 4) {
                return true;
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Password is less than 4 characters",
                });
                return false;
            }
        }
        return true;
    }
    // checkUserPass() {
    //     if (this.oldPassword !== "" && this.oldPassword !== undefined) {
    //         if (this.oldPassword === this.member.password) {
    //             if (this.newPassword !== "") {
    //                 if (this.newPassword === this.newConfirmPassword) {
    //                     this.member.password = this.newPassword;
    //                     return true;
    //                 } else {
    //                     this.messageService.clear();
    //                     this.messageService.add({
    //                         severity: "error",
    //                         summary: "Error Message",
    //                         detail: "User New Password and Confirm Password doesn't match",
    //                     });
    //                     return false;
    //                 }
    //             } else {
    //                 this.messageService.clear();
    //                 this.messageService.add({
    //                     severity: "error",
    //                     summary: "Error Message",
    //                     detail: "Please Enter New Password",
    //                 });
    //                 return false;
    //             }
    //         } else {
    //             this.messageService.clear();
    //             this.messageService.add({
    //                 severity: "error",
    //                 summary: "Error Message",
    //                 detail: "User password and Old password doesn't match",
    //             });
    //             return false;
    //         }
    //     }
    //     return true;
    // }
    isExcludedActivityType(activityType: string): boolean {
        // Define a regular expression pattern to match excluded property paths
        const excludedPatterns = [
          /^packageId$/,
          /^customerstrainer\.dueDate$/,
          /^oldDate$/,
          /^oldValue$/,
          /^currentUserData$/,
          /^type$/,
          /^scope$/,
          /^initiatedFrom$/,
          /^memberSettingFlag$/,
          /^modifiedBy$/,
          /^activityBy$/,
          /^attendance(\..*)?$/
      ];
        // Check if the activity type matches any of the excluded patterns
        return excludedPatterns.some(pattern => pattern.test(activityType));
    }

    formatOldValues(requestor) {
        let formattedOldValues = '';
        let counter = 1;
        requestor.updatedValues.forEach((updatedValue) => {
          if (!this.isExcludedActivityType(updatedValue.subjectType)) {
            if (formattedOldValues !== '') {
              formattedOldValues += '; ';
            }
            formattedOldValues += `${counter}. ${this.formatValue(updatedValue.oldValue)}`;
            counter++;
          }
        });
        return formattedOldValues;
      }


      formatNewValues(requestor) {
        let formattedNewValues = '';
        let counter = 1;

        requestor.updatedValues.forEach((updatedValue) => {
          // Check if the subjectType is 'profile'
          if (updatedValue.subjectType === 'profile') {
            updatedValue.newValue = 'profile changed';
            updatedValue.oldValue = 'profile changed';
          }

          // Exclude activity types as per existing logic
          if (!this.isExcludedActivityType(updatedValue.subjectType)) {
            if (formattedNewValues !== '') {
              formattedNewValues += '; ';
            }
            // Format and add the updated value
            formattedNewValues += `${counter}. ${this.formatValue(updatedValue.newValue)}`;
            counter++;
          }
        });

        return formattedNewValues;
      }

    formatValue(value) {
      if (this.isDate(value)) {
        return new Date(value).toLocaleDateString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });
      }
      return value;
    }

    isDate(value) {
      return !isNaN(Date.parse(value));
    }

    deletememberFees(fee: IMemberFeeDetails) {
        this.confirmationService.confirm({
            message: "Are you sure you want to Delete Fee ?",
            accept: () => {
                this.loading = true;
                fee.type = 'Delete Fee';
                fee.scope = 'Member';
                fee.initiatedFrom = 'Add Member';
                fee.name = this.member.name;
                fee.tagNumber = this.member.tagNumber;
                this.appServiceManager
                    .post("customerFees/deleteFee", fee)
                    .subscribe(
                        (response: any) => {
                            this.loading = false;
                            this.getCustomerByID();
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: "Fee Successfully Deleted",
                            });
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
            },
        });
    }

    getFormattedDueDate(dueDate: any): string {
        if (!dueDate) return 'N/A';

        const date = new Date(dueDate);
        if (isNaN(date.getTime())) return 'N/A';

        return this.getPackageValidityData(date.toISOString());
      }

    getPackageValidityData(dueDate: string): string {
        const dueDateMoment = moment(new Date(dueDate));
        const todayMoment = moment(new Date());

        if (dueDateMoment.isBefore(todayMoment)) {
            // Due date has passed
            const text = dueDateMoment.fromNow();
            return `Package expired ${text}.`;
        } else if (dueDateMoment.isAfter(todayMoment)) {
            // Due date is in the future
            const daysLeft = dueDateMoment.diff(todayMoment, 'days');
            return `Package will expire in ${daysLeft} days.`;
        } else {
            // Due date is today
            return `Package will expire today.`;
        }
    }
    getPackgeDays(dueDate: Date): number {
        const dueDateMoment = moment(dueDate).startOf('day');;
        const todayMoment = moment().startOf('day');
        const daysLeft = dueDateMoment.diff(todayMoment, 'days');
        return daysLeft;

    }


    setDate(res) {
        if (
            res.dateOfBirth === "null" ||
            res.dateOfBirth === null ||
            res.dateOfBirth === undefined
        ) {
            this.member.dateOfBirth = null;
        } else {
            var dateOfBirth = JSON.stringify(res.dateOfBirth);
            var DOB = JSON.parse(dateOfBirth).split("/");
            if (DOB.length === 1) {
                this.member.dateOfBirth = new Date(DOB);
            } else {
                var newDOBDate = DOB[1] + "/" + DOB[0] + "/" + DOB[2];
                if (newDOBDate) {
                    this.member.dateOfBirth = new Date(newDOBDate);
                }
            }
        }
        if (
            res.joiningDate === "null" ||
            res.joiningDate === null ||
            res.joiningDate === undefined
        ) {
            this.member.joiningDate = null;
        } else {
            var joiningDate = JSON.stringify(res.joiningDate);
            var JD = JSON.parse(joiningDate).split("/");
            if (JD.length === 1) {
                this.member.joiningDate = new Date(JD);
            } else {
                var newJDate = JD[1] + "/" + JD[0] + "/" + JD[2];
                if (newJDate) {
                    this.member.joiningDate = new Date(newJDate);
                }
            }
        }
        if (
            res.customerstrainer.dueDate === "" ||
            res.customerstrainer.dueDate === "null" ||
            res.customerstrainer.dueDate === null ||
            res.customerstrainer.dueDate === undefined
        ) {
            this.member.customerstrainer.dueDate = null;
        } else {
            var trainerDueDate = JSON.stringify(res.customerstrainer.dueDate);
            var TDD = JSON.parse(trainerDueDate).split("/");
            if (TDD.length === 1) {
                this.member.customerstrainer.dueDate = new Date(TDD);
            } else {
                var newTDDate = TDD[1] + "/" + TDD[0] + "/" + TDD[2];
                if (newTDDate) {
                    this.member.customerstrainer.dueDate = new Date(newTDDate);
                }
            }
        }
    }
    clearProfile($event) {
        this.member.profile = "";
    }
    uploadCustomerImage(file: any, memberId: string | Blob, isAddMode = false) {
        let formData: FormData = new FormData();
        if (file) {


            formData.append("customerImage", file, file.name);
            formData.append("isThumb", "true");
            formData.append("memberId", memberId);
            formData.append("company", this.companySessionStorage);
            formData.append("branch", this.branchSessionStorage);
            formData.append("isAddMode", isAddMode.toString());

            this.appServiceManager.post("customers/upload", formData)
                .subscribe(
                    (res: any) => {
                    },
                    (error: any) => {
                        this.messageService.clear();
                        this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
                    }
                );
        }
    }

    openWhatsAppProfile(member): string {

        let reciever = member.contactDetail.contact;
        if (member.contactDetail.contact) {
            let date = new Date(member.settings.dueDate);
            let month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
            let monthName = date.toLocaleString('en-US', { month: 'long' }); // Get the month name
            let year = date.getFullYear();

            let sessionData = localStorage.getItem('currentCompany');
            let parsedData = JSON.parse(sessionData);
            let name = parsedData.name;
            let msg = this.config.profileMessage;
            msg = msg.replace("{0}", member.name);
            msg = msg.replace("{1}", member._id);
            msg = msg.replace("{2}", this.user.company);
            msg = msg.replace("{3}", this.user.branch);
            msg = msg.replace("{4}", name);

            if (this.whatsAppCommunityLink) {
                msg = msg.replace("{5}", this.whatsAppCommunityLinkMessage);
              } else {
                msg = msg.replace("{5}", "");
              }


            const message = encodeURIComponent(msg);


                const link = document.createElement('a');
                link.href = `https://wa.me/${reciever}?text=${message}`;
                link.target = '_blank';
                link.click();
                return '';

        } else {
            // Show error message here
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: 'This user does not have a phone number',
            });
            return '';
        }
    }


    // showDialog() {
    //     this.selectedFileName = "";
    //     this.trainerSessions = this.member.customerstrainer.sessionCount;
    //     this.showTrainerFeeError = false;
    //     this.showRegistrationFeeError = false;
    //     this.showMonthlyFeeError = false;
    //     this.openFeeDialog = false;
    //     this.discountAmount = 0;
    //     this.previousDueDate = this.member.settings.dueDate;
    //     var date = new Date();
    //     this.fund.status = "Monthly Fee - Paid";
    //     if (this.member.settings.dueDate) {
    //         this.member.monthFee = this.packageFee;
    //         this.fund.pay = parseInt(this.member.monthFee) * this.numOfMonths;
    //         let percentagePaid = this.fund.pay / parseInt(this.member.monthFee) * 100;
    //         let numberOfDays: any = '';
    //         if (this.numOfMonths < 2) {
    //             if (this.fund.pay != parseInt(this.member.monthFee)) {
    //                 numberOfDays = (percentagePaid / 100) * 30;
    //             } else {
    //                 numberOfDays = moment(this.member.settings.dueDate); // Assuming a month is 30 days for other cases.
    //                 numberOfDays = numberOfDays.daysInMonth();
    //                 console.log("numberOfDays", numberOfDays)
    //             }
    //             numberOfDays = Math.floor(numberOfDays);
    //         }
    //         else {
    //             let months = [];
    //             months[0] = moment(this.member.settings.dueDate);
    //             months[0] = months[0].daysInMonth();
    //             let futureDate = moment(this.member.settings.dueDate)
    //             for (let i = 0; i < this.numOfMonths - 1; i++) {
    //                 futureDate = moment(futureDate).add(months[i], 'days');
    //                 months[i + 1] = futureDate.daysInMonth();
    //                 console.log("monthss:", months[i + 1]);
    //                 numberOfDays += Math.floor(months[i]);
    //                 numberOfDays = Math.floor(numberOfDays);
    //             }
    //             numberOfDays += Math.floor(months[this.numOfMonths - 1]);
    //             numberOfDays = Math.floor(numberOfDays);
    //         }

    //         let futureDate = moment(this.member.settings.dueDate).add(numberOfDays, 'days').toISOString();
    //         let futureDateTrainer = moment(this.member.customerstrainer.dueDate).add(numberOfDays, 'days').toISOString();
    //         console.log("futureDate", futureDate)

    //         if (this.fund.status == "Trainer Fee - Paid") {
    //             this.fund.dueDate = new Date(futureDateTrainer);
    //             this.fund.day = new Date(futureDateTrainer).getDate().toString();
    //         } else if (this.fund.status == "Fine Fee - Paid") {
    //             this.fund.dueDate = new Date();
    //             this.fund.day = new Date().getDate().toString();
    //         } else {
    //             this.fund.dueDate = new Date(futureDate);
    //             this.fund.day = new Date(futureDate).getDate().toString();
    //         }
    //         this.fund.date = new Date();

    //         this.fund.month = date.getMonth() + 1;
    //         this.fund.year = date.getFullYear();
    //         this.fundInvoice.pay = parseInt(this.member.monthFee);
    //         this.fundInvoice.date = new Date();
    //         this.dialogVisibility = this.isDialogVisible;
    //         var obj = {
    //             index: 1,
    //         };
    //         this.handleChange(obj);
    //         this.feeChange();
    //     } else {
    //         this.messageService.clear();
    //         this.messageService.add({
    //             severity: "error",
    //             summary: "Error Message",
    //             detail: "Please Set Due Date in Member Setting!",
    //         });
    //     }
    // }
    sessionCountChange() {
        this.sessionCountChanged = true;
    }
    // validateDiscount() {
    //     if (this.fund.status === 'Monthly Fee - Paid' && this.discountAmount > this.fund.pay) {
    //         this.showMonthlyFeeError = true;
    //     } else if (this.fund.status === 'Registration Fee - Paid' && this.discountAmount > this.fund.pay) {
    //         this.showRegistrationFeeError = true;
    //     } else if (this.fund.status === 'Trainer Fee - Paid' && this.discountAmount > this.fund.pay) {
    //         this.showTrainerFeeError = true;
    //     } else {
    //         this.showTrainerFeeError = false;
    //         this.showRegistrationFeeError = false;
    //         this.showMonthlyFeeError = false;
    //     }
    // }

    onPaymentModeChange(value: string) {
        this.paymentMode = value;
        const name = value.split("-")[1];
        const type = value.split("-")[0];
        const selectedPaymentMode = this.allPaymentOptions.filter(option => option.type === type && option.name === name)[0];
        this.taxType = selectedPaymentMode.taxSettings.taxCalculationType;
        this.taxRate = selectedPaymentMode.taxSettings.taxRate;
        this.subscriptionTax = (this.subscriptionFee - this.subscriptionDiscount) * this.taxRate/100.0;
        console.log(this.paymentMode);
    }

    onDiscountChange(){
        const name = this.paymentMode.split("-")[1];
        const type = this.paymentMode.split("-")[0];
        const selectedPaymentMode = this.allPaymentOptions.filter(option => option.type === type && option.name === name)[0];
        this.taxRate = selectedPaymentMode.taxSettings.taxRate;
        if(this.subscriptionDiscount <=this.subscriptionFee )
            this.subscriptionTax = (this.subscriptionFee - this.subscriptionDiscount) * this.taxRate/100.0;
        else
            this.subscriptionTax=0;
    }

    calculateTotalForNewSubscription() {
        let total = 0;
        let tax = 0;
        if(!this.subscriptionFee){
            this.subscriptionFee=0;
        }
        if(this.taxType === 'WITH_TAX') {
            tax = this.subscriptionTax || 0;
        }
        if(this.subscriptionFee >= this.subscriptionDiscount){
            total = (this.subscriptionFee + tax) - this.subscriptionDiscount;
            return total ;
        }
        else {
            return 0;
        }

    }
    onUploadButtonClick(): void {
        const fileInput = document.getElementById('fileInput') as HTMLInputElement;
        fileInput.click();
    }
    onAcknowledgeUploadButtonClick(): void {
        const fileInput = document.getElementById('acknowledgeFileInput') as HTMLInputElement;
        fileInput.click();
    }

    async ChangeEvent(event: any): Promise<void> {
        const file: File = event.target.files[0];
        this.selectedFileName = file.name;
        this.modifiedFileName = file.name + ":" + this.user.company + ":" + this.user.branch;
        const modifiedFile = new File([file], this.modifiedFileName, { type: file.type });
        this.selectedFile = modifiedFile;

        if (this.selectedFile) {
            const formData: FormData = new FormData();
            formData.append('acknowledgedImage', this.selectedFile, this.selectedFile.name);
            try {
                await this.uploadAcknowledgeImage(formData);
            } catch (error) { }
        }
    }
    uploadAcknowledgeImage(formData: FormData): Observable<any> {

        return this.appServiceManager.post("customers/upload/acknowledgedImageOnly", formData).toPromise()
            .then((res: any) => {
                this.member.acknowledgedImage = res.data.acknowledgedImageUrl;
            })
            .catch(error => {
                // Handle errors if needed
            });
    }
    // onUploadButtonClick(): void {
    //     const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    //     fileInput.click();
    // }

    // fileChangeEvent(event: any): void {
    //     const file: File = event.target.files[0];
    //     this.selectedFileName = file.name;
    //     this.modifiedFileName = file.name + ":" + this.user.company + ":" + this.user.branch;
    //     const modifiedFile = new File([file], this.modifiedFileName, { type: file.type });
    //     this.selectedFile = modifiedFile;
    // }

    // uploadReceipt(formData: FormData): Observable<any> {

    //     return this.appServiceManager.post("customers/upload/feereceiptOnly", formData).toPromise()
    //         .then((res: any) => {
    //             this.selectedFileName = res.data.feeReceiptImageUrl;
    //         })
    //         .catch(error => {
    //             // Handle errors if needed
    //         });
    // }

    // addFund() {
    //     this.fund.discountAmount = this.discountAmount;
    //     this.dialogVisibility = false;
    //     var terminDate: Date;
    //     var dateInLoop: Date;
    //     if (this.fund.status == "Trainer Fee - Paid") {
    //         this.fund.day = new Date(this.member.customerstrainer.dueDate).getDate().toString();
    //         this.numOfMonths = 1;
    //     }
    //     if (this.fund.status == 'Monthly Fee - Paid') {
    //         this.confirmationBoxMessage = 'Are you sure you want to add monthly fee ?';
    //     }
    //     else if (this.fund.status == 'Trainer Fee - Paid') {
    //         this.confirmationBoxMessage = 'Are you sure you want to add trainer fee ?';
    //     }
    //     else if (this.fund.status == 'Registration Fee - Paid') {
    //         this.confirmationBoxMessage = 'Are you sure you want to add registration fee ?';
    //     }
    //     else if (this.fund.status == 'Fine Fee - Paid') {
    //         this.confirmationBoxMessage = 'Are you sure you want to add fine fee ?';
    //     }
    //     this.confirmationService.confirm({
    //         message: this.confirmationBoxMessage,
    //         accept: async () => {
    //             if (this.fund.pay !== null && this.fund.pay >= 0) {

    //                 let counterCheck = 0;
    //                 let addFeeMonths = this.numOfMonths;
    //                 if (this.fund.status == "Registration Fee - Paid") {

    //                     addFeeMonths = 1;
    //                 }
    //                 this.fund.pay = Math.round(this.fund.pay / addFeeMonths);
    //                 for (let ind = 0; ind <= addFeeMonths - 1; ind++) {
    //                     this.fundCollectiveInvoice[ind] = new IMemberFeeDetails;
    //                     counterCheck = counterCheck + 1;

    //                     terminDate = new Date(this.member.settings.dueDate);

    //                     dateInLoop = new Date(this.member.settings.dueDate);
    //                     if (this.fund.status == "Trainer Fee - Paid") {
    //                         terminDate = new Date(this.member.customerstrainer.dueDate);
    //                         dateInLoop = terminDate;

    //                     }
    //                     dateInLoop.setDate(1);
    //                     dateInLoop.setMonth(terminDate.getMonth() + ind);
    //                     this.fundInvoice.pay = this.fund.pay;
    //                     this.fundCollectiveInvoice[ind].pay = this.fund.pay;
    //                     var paydate: any = this.datePipe.transform(
    //                         this.fund.date,
    //                         "MM/dd/yyyy,  h:mm a"
    //                     );
    //                     this.fund.date = paydate;
    //                     this.fund.day = new Date(this.fund.dueDate).getDate().toString();
    //                     this.fundInvoice.day = new Date(this.fund.dueDate).getDate().toString();
    //                     this.fundCollectiveInvoice[ind].day = new Date(this.fund.dueDate).getDate().toString();
    //                     this.fundInvoice.month = this.fund.month;
    //                     this.fundInvoice.year = this.fund.year;
    //                     if (this.fund.status == "Monthly Fee - Paid") {
    //                         this.fundInvoice.discount = Math.round(this.discountAmount / this.numOfMonths);
    //                         this.fund.discount = Math.round(this.discountAmount / this.numOfMonths);

    //                     }
    //                     else {
    //                         this.fundInvoice.discount = this.discountAmount;
    //                         this.fund.discount = this.discountAmount;

    //                     }
    //                     this.fundInvoice.status = this.fund.status;
    //                     this.fundCollectiveInvoice[ind].month = this.fund.month;
    //                     this.fundCollectiveInvoice[ind].year = this.fund.year;
    //                     this.fundCollectiveInvoice[ind].status = this.fund.status;
    //                     this.fund.memberId = this.memberID;
    //                     this.fundInvoice.description = this.fund.description;
    //                     this.fundCollectiveInvoice[ind].description = this.fund.description;
    //                     this.fund.isDelete = this.member.isDelete;
    //                     this.fund.isSynced = this.member.isSynced;
    //                     this.fund.isDefaulter = this.member.isDefaulter;
    //                     this.fund.type = 'Add Fee';
    //                     this.fund.scope = 'Member';
    //                     this.fund.initiatedFrom = 'Add Member';
    //                     this.fund.currentUserData = this.currentUserData;
    //                     this.fund.oldDate = this.member.oldDate;
    //                     this.fund.createdBy = this.currentUserData.name;
    //                     const currentDate = new Date();
    //                     const currentMonth = currentDate.getMonth() + 1;
    //                     const currentYear = currentDate.getFullYear();
    //                     this.fund.invoice = AppUtils.generateInvoiceNo(this.member.tagNumber, this.member.feeDetails, currentYear, currentMonth, false, counterCheck);
    //                     let lastDayOfMonthInLoop: any = new Date(dateInLoop.getFullYear(), dateInLoop.getMonth() + 1, 0);
    //                     if (lastDayOfMonthInLoop.getDate() < terminDate.getDate()) {
    //                         this.fund.day = lastDayOfMonthInLoop.getDate();
    //                         this.fund.month = dateInLoop.getMonth() + 1;
    //                         this.fund.year = dateInLoop.getFullYear();
    //                     }
    //                     else {
    //                         terminDate.setMonth(terminDate.getMonth() + ind);
    //                         this.fund.day = this.fund.day;
    //                         this.fund.month = terminDate.getMonth() + 1;
    //                         this.fund.year = terminDate.getFullYear();
    //                     }
    //                     this.fund.date = new Date();
    //                     this.fund.paymentMode = this.paymentMode;
    //                     if (this.selectedFile) {
    //                         const formData: FormData = new FormData();
    //                         formData.append('feeReceiptImage', this.selectedFile, this.selectedFile.name);
    //                         try {
    //                             await this.uploadReceipt(formData);
    //                             this.fund.feeReceiptImageUrl = this.selectedFileName;
    //                         } catch (error) { }
    //                     }
    //                     //this.fundCollectiveInvoice[ind]=this.fundInvoice;
    //                     this.fundInvoice.invoice = this.fund.invoice;
    //                     if (ind === 0) {
    //                         this.fundCollectiveInvoice[ind].invoice = this.fund.invoice;
    //                         this.firstInvoice = this.fund.invoice;
    //                     }
    //                     if (this.fund.status == "Trainer Fee - Paid") {
    //                         this.fund.remainingSessionCount = parseInt(this.trainerSessions);
    //                         this.fund.sessionCount = this.trainerSessions;
    //                         const url = `trainingAttendance/updateSessionCount/${this.member._id}`;
    //                         const body = { sessionCount: this.trainerSessions, flag: true };
    //                         this.appServiceManager.put(url, body).subscribe((res: any) => {
    //                             console.log('Update successful', res);
    //                         },
    //                             (error) => {
    //                                 // Handle the error
    //                                 console.error('Update failed', error);
    //                             }
    //                         );
    //                     }
    //                     // this.member.feeDetails.push({ ...this.fund });
    //                     this.appServiceManager
    //                         .post("customers/payFund", this.fund)
    //                         .subscribe(
    //                             (res: any) => {
    //                                 let flag = false;
    //                                 if (res.status) {

    //                                     this.getCustomerByID();
    //                                     if (addFeeMonths == 1) {
    //                                         this.printInvoice();
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "success",
    //                                             summary: "Success Message",
    //                                             detail: "Member Fee Submitted",
    //                                         });
    //                                         flag = true;
    //                                     }
    //                                     if (ind == addFeeMonths - 1 && flag === false) {
    //                                         this.printMultipleInvoices();
    //                                         this.messageService.clear();
    //                                         this.messageService.add({
    //                                             severity: "success",
    //                                             summary: "Success Message",
    //                                             detail: "Member Fee Submitted",
    //                                         });
    //                                     }

    //                                     this.dataService.refreshDefaulter("refreshDefaulters");
    //                                     if (this.member.isDelete || this.member.freezeDetail.isFreeze) {
    //                                         this.showActiceFreezeBox = true;
    //                                     }

    //                                 } else if (res.status == false) {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "error",
    //                                         summary: "Info Message",
    //                                         detail: res.error,
    //                                     });
    //                                 } else {
    //                                     this.messageService.clear();
    //                                     this.messageService.add({
    //                                         severity: "info",
    //                                         summary: "Info Message",
    //                                         detail: "Something Went Wrong",
    //                                     });
    //                                 }
    //                             },
    //                             (error) => {
    //                                 this.messageService.clear();
    //                                 this.messageService.add({
    //                                     severity: "error",
    //                                     summary: "Error Message",
    //                                     detail: error,
    //                                 });
    //                             }
    //                         );
    //                 }
    //             }
    //             else {
    //                 this.messageService.clear();
    //                 this.messageService.add({
    //                     severity: "warn",
    //                     summary: "Warning Message",
    //                     detail: "Monthly Fee Must be greater then -1.",
    //                 });
    //             }
    //         },
    //     });
    // }

    showAddProfileImage(type) {
        this.addProfileImage = type; // Upload | Cam
        this.isShowAddProfileImage = true;
    }
    removeProfileImage() {
        this.oldMemberImage = this.member.profile;
        this.uploadProfile = '';
        this.member.profile = '';
    }
    calculateTotal() {
        this.feeTotal = 0;
        this.feeTotalDiscount = 0;
        this.feeTotalTax = 0;
        if (this.customerFees) {
            if (this.customerFees.length > 0) {
                this.customerFees.forEach((record) => {
                    const pay = parseFloat(record.pay.toString());
                    let tax = 0;
                    if(record.tax === undefined || record.tax === null) {
                        tax = 0;
                    } else {
                        if(record.taxCalculationType !== "INCLUDING_TAX")
                            tax = parseFloat(record.tax.toString());
                    }
                    let discount = 0;
                    if(record.discount === undefined || record.discount === null) {
                        discount = 0;
                    } else {
                        discount = parseFloat(record.discount.toString());
                    }
                    this.feeTotal += pay;
                    this.feeTotalTax += (tax);
                    this.feeTotalDiscount += discount;
                });

                // Round final results to integers
                this.feeTotal =(this.feeTotal);
                this.feeTotalTax =(this.feeTotalTax);
                this.feeTotalDiscount =(this.feeTotalDiscount);
            }
        }
    }
    getRemainingBalance(invoiceNumber) {
        let remainingBalance = 0;
        let tax=0;
        if (this.customerFees) {
            if (this.customerFees.length > 0) {
                this.customerFees.forEach((record) => {
                    if (record.invoice === invoiceNumber) {
                        remainingBalance = parseFloat(record.balance || '0') ;
                        if(record.taxCalculationType == "WITH_TAX")
                        {
                            tax = remainingBalance * record.taxRate/100;
                            remainingBalance+=tax;
                        }

                    }
                });
            }
        }
        if (remainingBalance < 0) {
            remainingBalance = 0;
        }
        return remainingBalance.toLocaleString('en-US', {minimumFractionDigits:0});
    }

    refreshFeeDetails() {
        if (this.seletedStatus === "All") {
            let data = JSON.parse(this.feeDetailsSource);
            this.customerFees = data;
        } else {
            let data = JSON.parse(this.feeDetailsSource);
            let check = data.filter((x) => x.status === this.seletedStatus);
            this.customerFees = check;
        }
    }
    captureImageDialogShow() {
        if (this.dialogVisible == true) {
            this.dialogVisible = false;
        } else {
            this.dialogVisible = true;
        }
    }
    activateMember() {
        this.confirmationService.confirm({
            message: "Are you sure you want to Activate member ?",
            accept: () => {
                this.loading = true;
                this.member.isDelete = false;
                this.member.isSynced = false;
                this.member.type = 'Activate';
                this.member.scope = 'Member';
                this.member.initiatedFrom = 'Add Member';
                this.member.memberSettingFlag = true;
                this.member.currentUserData = this.currentUserData;
                this.appServiceManager
                    .put("customers/" + this.member._id, this.member)
                    .subscribe(
                        (res: any) => {
                            if (res.status === true) {
                                this.member = res.customer;
                                this.loading = false;
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Successfully Activated",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }

                    );
                this.member.memberSettingFlag = false;
            },
        });
    }
    freezeMember(member: IMember) {
        this.confirmationService.confirm({
            message: "Are you sure you want to Freeze member ?",
            accept: () => {
                this.loading = true;
                member.freezeDetail.daysLeft = this.getPackgeDays(member.settings.dueDate);
                this.member.freezeDetail.isFreeze = true;
                member.type = 'Freeze';
                member.scope = 'Member';
                member.initiatedFrom = 'Add Member';
                member.currentUserData = this.currentUserData;
                this.appServiceManager
                    .put("customers/freeze/" + this.member._id, member)
                    .subscribe(
                        (res: any) => {
                            if (res.status === true) {
                                this.messageService.clear();
                                this.loading = false;
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Successfully Freezed",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                            this.getFreezeReport();
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
            },
        });
    }
    defreezeMember(member: IMember) {
        this.confirmationService.confirm({
            message: "Are you sure you want to DeFreeze member ?",
            accept: () => {
                this.loading = true;
                member.freezeDetail.isFreeze = false;
                var checkDay = parseInt(member.freezeDetail.daysLeft.toString());
                let currentDate = new Date()
                let calculatedDate = moment(currentDate).add(checkDay, 'days').toISOString();
                member.settings.dueDate = new Date(calculatedDate);
                member.type = 'DeFreeze';
                member.scope = 'Member';
                member.initiatedFrom = 'Add Member';
                member.currentUserData = this.currentUserData;
                this.appServiceManager
                    .put("customers/defreeze/" + this.member._id, member)
                    .subscribe(
                        (res: any) => {
                            if (res.status === true) {
                                this.member = res.customer;
                                this.validateMember(this.member);
                                this.messageService.clear();
                                this.loading = false;
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Successfully DeFreezed",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                            this.getFreezeReport();
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
            },
        });
    }

    openPhoto(imageUrl: any) {
        this.imgPreview = true;
        this.imgPreviewImg = `${this.config.Server}/${this.config.feereceiptImagePath}/${imageUrl}`;
    }

    openAcknowledgePhoto(imageUrl: any) {
        this.imgPreview = true;
        this.imgPreviewImg = `${this.config.Server}/${this.config.memberImagePath}/${imageUrl}`;
    }

    closePhotoPreview() {
        this.imgPreview = false;
        this.imgPreviewImg = "";
    }

    hideAddProfileImage() {
        this.isShowAddProfileImage = false
    }

    updatePackage() {

        const selectedPackagename = this.packagesDropDown.find(package1 => package1.value === this.member.packageId);
        this.confirmationService.confirm({
            message: "Are you sure you want to update package ?",
            accept: () => {

                let selectedPackage: IPackageBuider = this.packages.find(x => x._id === this.member.packageId)
                this.member.company = this.user.company;
                this.member.branch = this.user.branch;
                this.member.type = 'Update Package';
                this.member.scope = 'Member';
                this.member.initiatedFrom = 'Add Member';
                this.updateMemberSettingFlag = true;
                this.member.memberSettingFlag = this.updateMemberSettingFlag;
                this.member.packageName = selectedPackagename.label;
                this.appServiceManager
                    .put("customers/" + this.member._id, this.member)
                    .subscribe(
                        (res: any) => {
                            if (res) {
                                this.member = res.customer;
                                this.feeDetailsSource = JSON.stringify(
                                    this.customerFees
                                );
                                this.validateMember(res.customer);
                                this.fund.pay = parseInt(
                                    this.member.monthFee
                                );
                                this.setDate(res.customer);
                                this.getCompany();
                                this.calculateTotal();
                                this.allowDialog = true;
                                this.loadPackages();
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Member Successfully Updated",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                        },
                        (error) => {
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        },
                        this.updateMemberSettingFlag = false
                    );
            },
        });
        this.isPackageDialogVisible = false;
        // }
    }

    loadPackages() {
        this.getPackages();
        this.getPackagesByID();
    }

    activityLogs(member) {
        member.currentUserData = this.currentUserData;
        member.type = 'Deactivate';
        member.scope = 'Member';
        member.initiatedFrom = 'Add Member';
        // Make an API call to log the activity
        this.appServiceManager.post('activityLogs/activityLogs', member).subscribe((logRes: any) => {
            // Handle the logging response here
        });
    }
    deActivateMember() {
        this.confirmationService.confirm({
            message: "Are you sure you want to deactivate member?",
            accept: () => {
                this.loading = true;
                this.appServiceManager
                    .delete("customers/" + this.member._id)
                    .subscribe(
                        (res: any) => {
                            if (res.status === true) {
                                this.activityLogs(this.member);
                                this.getCustomerByID();
                                this.messageService.clear();
                                this.loading = false;
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Successfully Deactivated",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
            },
        });
    }
    IsSyncedMember(member) {
        this.confirmationService.confirm({
            message: "Are you sure you want to Sync again?",
            accept: () => {
                this.loading = true;
                let payload = {
                    isSynced: false
                };
                this.appServiceManager.put('customers/issynced/' + member._id, payload).subscribe((res: any) => {
                    if (res.status === true) {
                        // this.DeleteMember(member);

                        this.messageService.clear();
                        this.loading = false;
                        this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Sync process has been started' });
                    } else {
                        this.messageService.clear();
                        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
                    }

                },
                    (error) => {
                        this.loading = false;
                        this.messageService.clear();
                        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                    });
            }
        });
    }
    addVitailspopup(){
    this.addVitalsDialog=true;
    this.showBodySpecPopup=true;
}

    payFee(){
        console.log("Before add fee")
        this.feeInvoiceDialog=true;
        this.dialogVisibility=true;

      }

      closeFeeCollectionDialog() {
        console.log("After add fee")
        this.dialogVisibility = false;
        this.feeInvoiceDialog = false;
        this.getCustomerByID();
        this.getCustomerFees();
      }

    handleImage(webcamImage: WebcamImage) {
        this.webcamImage = webcamImage;
        if (webcamImage) {
            this.uploadProfile = this.webcamImage;
            this.member.profile = this.webcamImage.imageAsDataUrl;
            this.webcamImage = null;
        }
    }

    handleImagefromNewProfile(webcamImage) {
        if (webcamImage) {
            this.uploadProfile = webcamImage;
            this.member.profile = webcamImage;
            this.webcamImage = null;
            this.hideAddProfileImage();
        }
    }

    cancelFreeze(freeze: IMemberFreezeDetail) {
        this.confirmationService.confirm({
            message: "Are you sure you want to cancel freeze ?",
            accept: () => {
                this.loading = true;
                this.member.freezeDetail.daysLeft = 0;
                this.member.freezeDetail.isFreeze = false;
                this.appServiceManager
                    .put("customers/cancelFreeze/" + this.member._id, this.member)
                    .subscribe(
                        (res: any) => {
                            if (res.status === true) {
                                this.member = res.customer;
                                this.validateMember(this.member);
                                this.messageService.clear();
                                this.loading = false;
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Successfully Cancelled the freezed",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                            this.getFreezeReport();
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
            },
        });
    }

    //   printing member details
    printMemberDetails(value) {
        this.member = new IMember();
        this.member = value;
        setTimeout(() => {
            this.printMemberDetailInvoice();
        }, 300);
    }

    printSelected(value) {
        this.fundInvoice = new IMemberFeeDetails();
        this.fundInvoice = value;
        setTimeout(() => {
            this.printInvoice();
        }, 300);
    }

    print(): void {
        let printContents, popupWin;
        printContents = document.getElementById("ID-card").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>Gym ID Card</title>
        <style>
            .ID-card {
                width: 400px;
                height: 250px;
                margin: auto;
                position: relative;
                padding: 20px;
                border-radius: 10px;
                background-image: url("https://i.ibb.co/NL188dQ/white-wood.png");
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.35);
                z-index: 10;
                filter: opacity(95%);
            }

            .top-row {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 5px 0;
            }

            .flag {
                height: 10px;
                margin-right: 5px;
            }

            .card-title,
            .card-title-en {
                line-height: 100%;
            }

            .name,
            .name-en,
            .ID-number {
                font-weight: normal;
            }

            .card-title-en {
                margin-left: auto;
            }

            .middle-row {
                margin-top: 30px;
                display: inline-block;
            }

            .bottom-row {
                position: absolute;
                bottom: 20px;
            }

            .ID-photo {
                display: block;
                width: 100px;
                height: 128px;
                background-repeat: no-repeat;
                background-position: -90px center;
                background-size: 250px;
                position: absolute;
                top: 60px;
                right: 20px;
            }

            .series-number {
                writing-mode: vertical-rl;
                transform: rotate(180deg);
                position: absolute;
                right: -20px;
                bottom: 66px;
                z-index: 10;
            }

            .signature-title {
                position: absolute;
                bottom: 20px;
                right: 20px;
            }

            .signature {
                font-family: "Liu Jian Mao Cao", cursive;
                font-weight: 100;
                position: absolute;
                right: 40px;
                bottom: 35px;
            }

            .ID-number {
                line-height: 100%;
                margin-top: 5px;
            }

            .title {
                text-align: center;
                margin: 16px;
                font-weight: normal;
                font-size: 16px;
                width: 100%;
                position: absolute;
                bottom: 20px;
                z-index: 10;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }

    // PRINTING MEMBER DETAIL INVOICE
    printMemberDetailInvoice(): void {
        let printContents, popupWin;
        printContents = document.getElementById("memberinvoice").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>Member Detail Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            .heading td {
              font-size: 13px;
            }
            .item td {
                font-size: 13px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }

    printInvoice(): void {
        let printContents, popupWin;
        let currentDate = new Date();
        this.branch.name = this.branch.name
        printContents = document.getElementById("invoice").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            .heading td {
              font-size: 13px;
            }
            .item td {
                font-size: 13px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }
    printMultipleInvoices(): void {
        let printContents, popupWin;
        let currentDate = new Date();
        this.branch.name = this.branch.name
        printContents = document.getElementById("multipleInvoices").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            .heading td {
              font-size: 13px;
            }
            .item td {
                font-size: 13px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }

    getBranchById() {
        this.loading = true;
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            this.branchName = this.branch.name;
            this.invoiceData = this.branch.invoiceData;
            this.whatsAppCommunityLink = this.branch.whatsappCommunityInvitationLink;
            this.whatsAppCommunityLinkMessage = "\n\nWe also have a vibrant WhatsApp community where our members share tips, motivation, and support each other's fitness journeys. If you'd like to join this community, simply tap on this link\n" + this.whatsAppCommunityLink;
            this.allPaymentOptions = this.branch.payments;
            if (Array.isArray(this.branch.payments)) {
                this.branch.payments.forEach(payment => {
                    const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                    if (!existingBank) {
                        this.paymentOptions.push({
                            label: `${payment.type} - ${payment.name}`,
                            value: `${payment.type}-${payment.name}`
                        });
                    }
                });
            }
            this.onPaymentModeChange(this.paymentMode);
            this.loading = false;
        }
        if(!this.branch){
            this.appServiceManager.get('branches/' + AuthService.getLoggedInBranch()).subscribe((res) => {
                if (res) {
                    this.branchName = res.name;
                    this.invoiceData = res.invoiceData;
                    this.whatsAppCommunityLink = res.whatsappCommunityInvitationLink;
                    this.whatsAppCommunityLinkMessage = "\n\nWe also have a vibrant WhatsApp community where our members share tips, motivation, and support each other's fitness journeys. If you'd like to join this community, simply tap on this link\n" + this.whatsAppCommunityLink;
                    this.allPaymentOptions = res.payments;
                    res.payments.forEach(payment => {
                        const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
                        if (!existingBank) {
                            this.paymentOptions.push({
                                label: `${payment.type} - ${payment.name}`,
                                value: `${payment.type}-${payment.name}`
                            });
                        }
                    });

                    this.onPaymentModeChange(this.paymentMode);
                } else {
                    this.messageService.clear();
                    this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
                }
                this.loading = false;
            },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                });
        }
    }

    openDialog(fee) {
        if (fee.description) {
            this.dialogDescription = fee.description;
        } else {
            this.dialogDescription = "No Comments";
        }
        this.showCommentDialog = true;
        document.body.classList.add('showCommentDialog');
    }

    openSubscriptionDialog(subscription) {
        if (subscription.description) {
            this.dialogDescription = subscription.description;
        } else {
            this.dialogDescription = "No Comments";
        }
        this.showCommentDialog = true;
        document.body.classList.add('showCommentDialog');
    }
    closeDialog() {
        this.showCommentDialog = false;
        document.body.classList.remove('showCommentDialog');
    }
    closeAddBodyVitalsDialog() {
        this.addVitalsDialog = false;
        this.getBodySpecification();
    }

    openWhatsApp(fee) {
        console.log(fee)
        console.log(this.member)
        let reciever = this.member.contactDetail.contact;
        if (this.member.contactDetail.contact) {
            let invoice = fee.invoice;
            invoice = encodeURIComponent(invoice);
            invoice = invoice.replace(/^Inv%/, "Inv#");
            let pay = parseInt(fee.pay);
            let tax = parseInt(fee.tax);
            if(this.taxType === "WITH_TAX") {
                if(tax !== undefined && tax !== null && tax > 0) {
                    pay = pay + tax;
                }
            }
            let discount = parseInt(fee.discount);
            if(discount !== null && discount !== undefined && discount > 0) {
                pay = pay - discount;
            }
            let status = fee.status;
            let dueDate = this.member.settings.dueDate;
            const formatteddueDate = dueDate.toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric'
            });

            if(pay <= 0) {
                pay = 0;
            }

            let date = new Date(fee.date);
            let month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
            let monthName = date.toLocaleString('en-US', { month: 'long' }); // Get the month name
            let year = date.getFullYear();
            let day = date.getDate();
            let sessionData = localStorage.getItem('currentCompany');
            let parsedData = JSON.parse(sessionData);
            let name = parsedData.name;
            let msg = this.config.invoiceMessage;
            msg = msg.replace("{0}", this.member.name);
            msg = msg.replace("{1}", monthName);
            msg = msg.split("{2}").join(year.toString());
            msg = msg.replace("{3}", day.toString());
            msg = msg.replace("{4}", monthName.toString());
            msg = msg.replace("{5}", year.toString());
            msg = msg.replace("{6}", invoice);
            msg = msg.replace("{7}", pay.toString());
            if (!this.hideTaxInfo) {
                msg = msg.replace("{13}", "\n*Tax:* "+ fee.tax);
            }else{
                msg = msg.replace("{13}", "");
            }
            msg = msg.replace("{8}", status);
            msg = msg.replace("{9}", formatteddueDate);
            msg = msg.replace("{10}", this.member.tagNumber);
            msg = msg.replace("{11}", this.branchName);

            if(this.whatsAppCommunityLink){
                msg = msg.replace("{12}", this.whatsAppCommunityLinkMessage);
            }else{
                msg = msg.replace("{12}", '');
            }
            const message = encodeURIComponent(msg);

                const link = document.createElement('a');
                link.href = `https://wa.me/${reciever}?text=${message}`;
                link.target = '_blank';
                link.click();
                return '';

        } else {
            // Show error message here
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: 'This user does not have a phone number',
            });
            return '';
        }

    }

    openWhatsAppForSubscriptionFee(fee, due) {
        console.log(fee)
        console.log(this.member)
        let reciever = this.member.contactDetail.contact;
        if (this.member.contactDetail.contact) {
            let invoice = fee.invoice;
            invoice = encodeURIComponent(invoice);
            invoice = invoice.replace(/^Inv%/, "Inv#");
            let pay = parseInt(fee.pay);
            let tax = parseInt(fee.tax);
            if(this.taxType === "WITH_TAX") {
                if(tax !== undefined && tax !== null && tax > 0) {
                    pay = pay + tax;
                }
            }
            let discount = parseInt(fee.discount);
            if(discount !== null && discount !== undefined && discount > 0) {
                pay = pay - discount;
            }
            let status = fee.status;
            let dueDate = new Date(due);
            const formatteddueDate = dueDate.toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric'
            });

            if(pay <= 0) {
                pay = 0;
            }

            let date = new Date(fee.date);
            let month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
            let monthName = date.toLocaleString('en-US', { month: 'long' }); // Get the month name
            let year = date.getFullYear();
            let day = date.getDate();

            let sessionData = localStorage.getItem('currentCompany');
            let parsedData = JSON.parse(sessionData);
            let name = parsedData.name;
            let msg = this.config.invoiceMessage;
            msg = msg.replace("{0}", this.member.name);
            msg = msg.replace("{1}", monthName);
            msg = msg.split("{2}").join(year.toString());
            msg = msg.replace("{3}", day.toString());
            msg = msg.replace("{4}", monthName.toString());
            msg = msg.replace("{5}", year.toString());
            msg = msg.replace("{6}", invoice);
            msg = msg.replace("{7}", pay.toString());
            if (!this.hideTaxInfo) {
                msg = msg.replace("{13}", "\n*Tax:* "+ fee.tax);
            }else{
                msg = msg.replace("{13}", "");
            }
            msg = msg.replace("{8}", status);
            msg = msg.replace("{9}", formatteddueDate);
            msg = msg.replace("{10}", this.member.tagNumber);
            msg = msg.replace("{11}", this.branchName);

            if(this.whatsAppCommunityLink){
                msg = msg.replace("{12}", this.whatsAppCommunityLinkMessage);
            }else{
                msg = msg.replace("{12}", '');
            }

            const message = encodeURIComponent(msg);

                const link = document.createElement('a');
                link.href = `https://wa.me/${reciever}?text=${message}`;
                link.target = '_blank';
                link.click();
                return '';
        } else {
            // Show error message here
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: 'This user does not have a phone number',
            });
            return '';
        }

    }
    openWhatsAppWelcome(): string {
        let reciever = this.member.contactDetail.contact;
        if (this.member.contactDetail.contact) {
          let sessionData = localStorage.getItem('currentCompany');
          let parsedData = JSON.parse(sessionData);
          let name = parsedData.name;
          let msg =  this.config.welcomeMessage;

          msg = msg.replace("{0}", this.member.name);
          msg = msg.replace("{1}", name);
          msg = msg.replace("{3}", name);

          if(this.whatsAppCommunityLink){
          msg = msg.replace("{4}", this.whatsAppCommunityLinkMessage);
          }else{
          msg = msg.replace("{4}", '');
          }

          const message = encodeURIComponent(msg);

            const link = document.createElement('a');
            link.href = `https://wa.me/${reciever}?text=${message}`;
            link.target = '_blank';
            link.click();
            return '';

        } else {
          // Show error message here
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: 'This user does not have a phone number',
          });
          return '';
        }
      }
    printAllInvoice(): void {
        let printContents, popupWin;
        let currentDate = new Date();
        this.branch.name = this.branch.name + " " + currentDate.getDate() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
        printContents = document.getElementById("allInvoice").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }

    openAllReceiptEmailConfirmation() {
        this.closeEmailConfirmation();
        this.showEmailReceiptConfirmationBox = true;
        this.email.to = this.member.email;
        this.email.subject = this.branch.name + ' | ' + 'All Invoices Receipt' + ' | ' + 'Date:' + this.datePipe.transform(new Date(), 'dd-MMM-yy');
        this.email.body = '<p><strong>Dear Customer</strong>,</p><p>Following is a receipt of all invoices of your<i> Gym Fee</i>, The receipt details are as under:</p>' + this.getAllReceiptEmailBodyHtml();
    }

    openSingleReceiptEmailConfirmation(value) {
        this.closeEmailConfirmation();
        this.showEmailSingleReceiptConfirmationBox = true;
        this.fundInvoice = new IMemberFeeDetails();
        this.fundInvoice = value;
        setTimeout(() => {
            this.getSingleInvoicesHtml();
        }, 300);
        this.email.to = this.member.email;
        this.email.subject = this.branch.name + ' | ' + 'Invoice Receipt' + ' | ' + 'Invoice Date:' + this.datePipe.transform(new Date(value.date), 'dd-MMM-yy');
        setTimeout(() => {
            let singleHtmlBody: any = this.getSingleReceiptEmailBodyHtml();
            this.email.body = '<p><strong>Dear Customer</strong>,</p><p>Following is an invoice receipt of your<i> Gym Fee</i>, The receipt details are as under:</p>' + singleHtmlBody;
        }, 100);

    }

    closeEmailConfirmation() {
        if (this.showEmailReceiptConfirmationBox) {
            this.showEmailReceiptConfirmationBox = false;

        } else if (this.showEmailSingleReceiptConfirmationBox) {
            this.showEmailSingleReceiptConfirmationBox = false;
        }
    }
    getAllInvoicesHtml() {
        let printContents;
        printContents = document.getElementById('allInvoice').innerHTML;
        let htmlToPdf = `<html>
		<head>
			 <title>Gym Invoice</title>
			 <style>
				  .invoice-box {
						max-width: 800px;
						margin: auto;
						padding: 30px;
						border: 1px solid #eee;
						box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
						font-size: 16px;
						line-height: 24px;
						font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
						color: #555;
				  }

				  .invoice-box table {
						width: 100%;
						line-height: inherit;
						text-align: left;
				  }

				  .invoice-box table td {
						padding: 5px;
						vertical-align: top;
				  }

				  .invoice-box table tr td:nth-child(n + 2) {
						text-align: right;
				  }

				  .invoice-box table tr.top table td {
						padding-bottom: 20px;
				  }

				  .invoice-box table tr.top table td.title {
						font-size: 45px;
						line-height: 45px;
						color: #333;
				  }

				  .invoice-box table tr.information table td {
						padding-bottom: 40px;
				  }

				  .invoice-box table tr.heading td {
						background: #eee;
						border-bottom: 1px solid #ddd;
						font-weight: bold;
				  }

				  .invoice-box table tr.details td {
						padding-bottom: 20px;
				  }

				  .invoice-box table tr.item td {
						border-bottom: 1px solid #eee;
				  }
				  .invoice-box table tr.item.last td {
						border-bottom: none;
				  }
				  .invoice-box table tr.item input {
						padding-left: 5px;
				  }
				  .invoice-box table tr.item td:first-child input {
						margin-left: -5px;
						width: 100%;
				  }
				  .invoice-box table tr.total td:nth-child(2) {
						border-top: 2px solid #eee;
						font-weight: bold;
				  }
				  .invoice-box input[type="number"] {
						width: 60px;
				  }
				  @media only screen and (max-width: 600px) {
						.invoice-box table tr.top table td {
							 width: 100%;
							 display: block;
							 text-align: center;
						}

						.invoice-box table tr.information table td {
							 width: 100%;
							 display: block;
							 text-align: center;
						}
				  }
				  .rtl {
						direction: rtl;
						font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
							 sans-serif;
				  }
				  .rtl table {
						text-align: right;
				  }
				  .rtl table tr td:nth-child(2) {
						text-align: left;
				  }
			 </style>
		</head>
		<body>${printContents}</body>
		</html>`

        return htmlToPdf;
    }

    getSingleInvoicesHtml() {
        let printContents;
        printContents = document.getElementById('invoice').innerHTML;
        let htmlToPdf = `<html>
		<head>
			 <title>Gym Invoice</title>
			 <style>
				  .invoice-box {
						max-width: 800px;
						margin: auto;
						padding: 30px;
						border: 1px solid #eee;
						box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
						font-size: 16px;
						line-height: 24px;
						font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
						color: #555;
				  }

				  .invoice-box table {
						width: 100%;
						line-height: inherit;
						text-align: left;
				  }

				  .invoice-box table td {
						padding: 5px;
						vertical-align: top;
				  }

				  .invoice-box table tr td:nth-child(n + 2) {
						text-align: right;
				  }

				  .invoice-box table tr.top table td {
						padding-bottom: 20px;
				  }

				  .invoice-box table tr.top table td.title {
						font-size: 45px;
						line-height: 45px;
						color: #333;
				  }

				  .invoice-box table tr.information table td {
						padding-bottom: 40px;
				  }

				  .invoice-box table tr.heading td {
						background: #eee;
						border-bottom: 1px solid #ddd;
						font-weight: bold;
				  }

				  .invoice-box table tr.details td {
						padding-bottom: 20px;
				  }

				  .invoice-box table tr.item td {
						border-bottom: 1px solid #eee;
				  }
				  .invoice-box table tr.item.last td {
						border-bottom: none;
				  }
				  .invoice-box table tr.item input {
						padding-left: 5px;
				  }
				  .invoice-box table tr.item td:first-child input {
						margin-left: -5px;
						width: 100%;
				  }
				  .invoice-box table tr.total td:nth-child(2) {
						border-top: 2px solid #eee;
						font-weight: bold;
				  }
				  .invoice-box input[type="number"] {
						width: 60px;
				  }
				  @media only screen and (max-width: 600px) {
						.invoice-box table tr.top table td {
							 width: 100%;
							 display: block;
							 text-align: center;
						}

						.invoice-box table tr.information table td {
							 width: 100%;
							 display: block;
							 text-align: center;
						}
				  }
				  .rtl {
						direction: rtl;
						font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
							 sans-serif;
				  }
				  .rtl table {
						text-align: right;
				  }
				  .rtl table tr td:nth-child(2) {
						text-align: left;
				  }
			 </style>
		</head>
		<body>${printContents}</body>
		</html>`

        return htmlToPdf;
    }

    sendInvoiceEmailAsPdf() {
        if (this.showEmailReceiptConfirmationBox) {
            let htmlToPdf = this.getAllInvoicesHtml();
            this.confirmationService.confirm({
                message: "Are you sure you want to proceed ?",
                accept: () => {
                    this.loader.show();
                    this.loading = true;
                    this.appServiceManager.post('customers/sendEmailWhileInvoicReceiptePrint',
                        {
                            data: htmlToPdf,
                            invoiceDay: this.fundInvoice.date,
                            subject: this.email.subject,
                            body: this.email.body,
                            to: this.email.to,
                            company: this.company.name

                        }).subscribe((res) => {
                            this.loading = false;
                            this.loader.hide();
                            this.showEmailReceiptConfirmationBox = false;
                            this.messageService.clear();
                            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Attachment Sent Successfully!" });
                        },
                            (error) => {
                                this.loading = false;
                                this.loader.hide();
                                this.showEmailReceiptConfirmationBox = false;
                                this.messageService.clear();
                                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                            }
                        )
                }
            });

        } else if (this.showEmailSingleReceiptConfirmationBox) {
            let htmlToPdf = this.getSingleInvoicesHtml();
            this.confirmationService.confirm({
                message: "Are you sure you want to proceed ?",
                accept: () => {
                    this.loader.show();
                    this.loading = true;
                    this.appServiceManager.post('customers/sendEmailWhileInvoicReceiptePrint',
                        {
                            data: htmlToPdf,
                            invoiceDay: this.fundInvoice.date,
                            subject: this.email.subject,
                            body: this.email.body,
                            to: this.email.to,
                            company: this.company.name

                        }).subscribe((res) => {
                            this.loading = false;
                            this.loader.hide();
                            this.showEmailSingleReceiptConfirmationBox = false;
                            this.messageService.clear();
                            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Attachment Sent Successfully!" });
                        },
                            (error) => {
                                this.loading = false;
                                this.loader.hide();
                                this.showEmailSingleReceiptConfirmationBox = false;
                                this.messageService.clear();
                                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                            }
                        )
                }
            });
        }
    }

    getAllReceiptEmailBodyHtml() {
        let printContents;
        printContents = document.getElementById('allInvoiceHtmlBody').innerHTML;
        this.htmlToPdf = `<html>
		<body>${printContents}</body>
        </html>`

        return this.htmlToPdf;
    }

    getSingleReceiptEmailBodyHtml() {
        let printContents;
        printContents = document.getElementById('invoiceHtmlBody').innerHTML;
        this.htmlToPdf = `<html>
		<body>${printContents}</body>
		</html>`

        return this.htmlToPdf;
    }

    ShowCommentBox(fee) {
        if (fee.description != undefined) {
            this.showCommentBox = true;
            this.fund.description = fee.description;
        } else {
            return;
        }
    }

    handleSwitchChange() {
        let data = {
            company: this.user.company,
            branch: this.user.branch,
            isLocked: this.member.isLocked,
            modifiedBy: this.user._id
        }
        this.appServiceManager
            .put("customers/changeLockedStatus/" + this.member._id, data)
            .subscribe((res: any) => {
                if (res) {
                    this.member = res.customer;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Status Successfully changed",
                    });
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something Went Wrong",
                    });
                }
            },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }


    getTrainerShare() {
        var x = parseInt(this.member.customerstrainer.totalFees) - parseInt(this.member.customerstrainer.gymShare);
        if (isNaN(x)) {
            this.member.customerstrainer.trainerShare = undefined;
            this.isGymShareMoreThanTrainerFee = true;

        } else {
            if (x >= 0) {
                this.member.customerstrainer.trainerShare = x.toString();
                this.isGymShareMoreThanTrainerFee = false;

            } else {
                this.member.customerstrainer.trainerShare = undefined;
                this.isGymShareMoreThanTrainerFee = true;
            }

        }
    }

    onChangeTrainerFee() {
        this.member.customerstrainer.trainerShare = '0';
        this.member.customerstrainer.gymShare = '0';
    }

    checkEmailExistence() {
        if (this.member.email != undefined && this.member.email.length > 0) {
            this.isEmailLoader = true;
            let data = { email: this.member.email, company: this.companySessionStorage, branch: this.branchSessionStorage };
            this.appServiceManager.post("customers/checkEmailExistence", data).subscribe(
                (member: any) => {
                    if (member.isEmailExist) {
                        this.isEmailExist = true;
                        this.isDisableOnTypeEmail = true;
                        setTimeout(() => {
                            this.isEmailLoader = false;

                        }, 1000);
                    } else {
                        this.isEmailExist = false;
                        this.isDisableOnTypeEmail = false;

                        setTimeout(() => {
                            this.isEmailLoader = false;
                        }, 2000);
                    }
                },
                (error) => {
                }
            );
        }
    }
    isDateDisabled(): boolean {
        return this.role.name.toLowerCase() === 'operator' || this.role.name.toLowerCase() === 'trainer';
    }
    getInvoiceDateColor(fee: any): string {
        const dueDate = new Date(fee.year, fee.month - 1, fee.day);
        const invoiceDate = new Date(fee.date);

        if (dueDate > invoiceDate) {
            return 'green';
        }
        else if (dueDate.getDate() == invoiceDate.getDate() && dueDate.getMonth() + 1 == invoiceDate.getMonth() + 1 && dueDate.getFullYear() == invoiceDate.getFullYear()) {
            return 'green';
        }
        else {
            return 'red';
        }
    }
    getMonthName(month: number): string {
        return AppUtils.getMonthName(month);
    }
    checkEmailExistEvent(e) {
        this.isDisableOnTypeEmail = true;
        if (e.target.value.length > 0 && e.target.value != this.dbEmailIfCustomerHAve) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.checkEmailExistence()
            }, 1000);
        } else {
            clearTimeout(this.timer);
            this.isEmailExist = false;
            this.isDisableOnTypeEmail = false;
        }
    }

    hotkeysMemberDetails($event) {
        if (($event.keyCode == 39 || $event.keyCode == 37) && this.mode == "edit") {
            var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
            var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
            var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
            if (confirmationBoxButtonExistLength > 0) {
                if (document.activeElement.tagName === "BODY") {
                    confirmationBoxButtonExist[0].focus();
                }
                else {
                    if (document.activeElement === confirmationBoxButtonExist[0]) {
                        confirmationBoxButtonExist[1].focus();
                    }
                    else if (document.activeElement === confirmationBoxButtonExist[1]) {
                        confirmationBoxButtonExist[0].focus();
                    }
                    else {
                        confirmationBoxButtonExist[0].focus();
                    }
                }
            }
        }
    }
}
